(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5069],{

/***/ 12281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cT": function() { return /* binding */ uploadFile; }
/* harmony export */ });
/* unused harmony exports uploadMultipleFiles, getFileUrl */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var API__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74453);
/* harmony import */ var API_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76214);





function uploadFile(file, onUploadProgress) {
    return _uploadFile.apply(this, arguments);
}
function _uploadFile() {
    _uploadFile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file, onUploadProgress) {
        var body, response, response1;
        return _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    body = new FormData();
                    body.append("file", file, file.name);
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return API__WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .h.post("/upload-file", body, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        onUploadProgress: onUploadProgress !== null && onUploadProgress !== void 0 ? onUploadProgress : function() {}
                    });
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    _ctx.prev = 11;
                    _ctx.next = 14;
                    return API__WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .h.post("/upload-file", body, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        onUploadProgress: onUploadProgress !== null && onUploadProgress !== void 0 ? onUploadProgress : function() {}
                    });
                case 14:
                    response1 = _ctx.sent;
                    return _ctx.abrupt("return", response1.data);
                case 18:
                    _ctx.prev = 18;
                    _ctx.t1 = _ctx["catch"](11);
                    (0,API_error__WEBPACK_IMPORTED_MODULE_3__/* .handleError */ .S)(_ctx.t1, "API/fileUploader", "uploadFile2");
                    return _ctx.abrupt("return", "");
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ],
            [
                11,
                18
            ]
        ]);
    }));
    return _uploadFile.apply(this, arguments);
}
function uploadMultipleFiles(files, onUploadProgress) {
    return _uploadMultipleFiles.apply(this, arguments);
}
function _uploadMultipleFiles() {
    _uploadMultipleFiles = _async_to_generator(regeneratorRuntime.mark(function _callee(files, onUploadProgress) {
        var body, response, errorMessage;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    body = new FormData();
                    files.forEach(function(file) {
                        return body.append("files", file, file.name);
                    });
                    _ctx.next = 5;
                    return api.post("/upload-multiple-files", body, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        onUploadProgress: onUploadProgress !== null && onUploadProgress !== void 0 ? onUploadProgress : function() {}
                    });
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    errorMessage = get(_ctx.t0, "response.data.error.message", "") || JSON.stringify(_ctx.t0);
                    ;
                    return _ctx.abrupt("return", []);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return _uploadMultipleFiles.apply(this, arguments);
}
function getFileUrl(fileName) {
    return _getFileUrl.apply(this, arguments);
}
function _getFileUrl() {
    _getFileUrl = _async_to_generator(regeneratorRuntime.mark(function _callee(fileName) {
        var response, errorMessage;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api.get("/file/".concat(fileName));
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    errorMessage = get(_ctx.t0, "response.data.error.message", "") || JSON.stringify(_ctx.t0);
                    ;
                    return _ctx.abrupt("return", "");
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return _getFileUrl.apply(this, arguments);
}


/***/ }),

/***/ 54166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Co": function() { return /* binding */ uploadCriminalReport; },
/* harmony export */   "L_": function() { return /* binding */ authenticateCRS; },
/* harmony export */   "QP": function() { return /* binding */ uploadEvictionReport; },
/* harmony export */   "Wt": function() { return /* binding */ getFICOCreditScore; },
/* harmony export */   "we": function() { return /* binding */ uploadCRSReport; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var API__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74453);
/* harmony import */ var API_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76214);





var BASE_PATH = "/customer/house-applications";
function getFICOCreditScore(tenantData) {
    return _getFICOCreditScore.apply(this, arguments);
}
function _getFICOCreditScore() {
    _getFICOCreditScore = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tenantData) {
        var url, response, errorMessage;
        return _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    url = "".concat(BASE_PATH, "/crs-credit-score");
                    _ctx.next = 4;
                    return API__WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .h.post(url, tenantData);
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    errorMessage = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(_ctx.t0, "response.data.error.message", "") || JSON.stringify(_ctx.t0);
                    (0,API_error__WEBPACK_IMPORTED_MODULE_3__/* .handleError */ .S)(_ctx.t0, "API/houseApplication", "getFICOCreditScore");
                    throw new Error(errorMessage);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return _getFICOCreditScore.apply(this, arguments);
}
function authenticateCRS() {
    return _authenticateCRS.apply(this, arguments);
}
function _authenticateCRS() {
    _authenticateCRS = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var url, errorMessage;
        return _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    url = "".concat(BASE_PATH, "/crs-auth");
                    _ctx.next = 4;
                    return API__WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .h.post(url);
                case 4:
                    _ctx.next = 11;
                    break;
                case 6:
                    _ctx.prev = 6;
                    _ctx.t0 = _ctx["catch"](0);
                    errorMessage = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(_ctx.t0, "response.data.error.message", "") || JSON.stringify(_ctx.t0);
                    (0,API_error__WEBPACK_IMPORTED_MODULE_3__/* .handleError */ .S)(_ctx.t0, "API/houseApplication", "authenticateCRS");
                    throw new Error(errorMessage);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                6
            ]
        ]);
    }));
    return _authenticateCRS.apply(this, arguments);
}
function uploadCRSReport(pdfReportId, phoneNumber, buildiumUnitId) {
    return _uploadCRSReport.apply(this, arguments);
}
function _uploadCRSReport() {
    _uploadCRSReport = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(pdfReportId, phoneNumber, buildiumUnitId) {
        var url, errorMessage;
        return _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    url = "".concat(BASE_PATH, "/crs-upload-report");
                    _ctx.next = 4;
                    return API__WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .h.post(url, {
                        pdfReportId: pdfReportId,
                        phoneNumber: phoneNumber,
                        buildiumUnitId: buildiumUnitId
                    });
                case 4:
                    _ctx.next = 11;
                    break;
                case 6:
                    _ctx.prev = 6;
                    _ctx.t0 = _ctx["catch"](0);
                    errorMessage = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(_ctx.t0, "response.data.error.message", "") || JSON.stringify(_ctx.t0);
                    (0,API_error__WEBPACK_IMPORTED_MODULE_3__/* .handleError */ .S)(_ctx.t0, "API/houseApplication", "uploadCRSReport");
                    throw new Error(errorMessage);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                6
            ]
        ]);
    }));
    return _uploadCRSReport.apply(this, arguments);
}
function uploadCriminalReport(phoneNumber, buildiumUnitId, tenantData) {
    return _uploadCriminalReport.apply(this, arguments);
}
function _uploadCriminalReport() {
    _uploadCriminalReport = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(phoneNumber, buildiumUnitId, tenantData) {
        var url, ref, ref1, ref2, errorMessage;
        return _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    url = "".concat(BASE_PATH, "/upload-crs-criminal-report");
                    _ctx.next = 4;
                    return API__WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .h.post(url, {
                        tenantData: tenantData,
                        phoneNumber: phoneNumber,
                        buildiumUnitId: buildiumUnitId
                    });
                case 4:
                    _ctx.next = 12;
                    break;
                case 6:
                    _ctx.prev = 6;
                    _ctx.t0 = _ctx["catch"](0);
                    ;
                    errorMessage = (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.error) === null || ref2 === void 0 ? void 0 : ref2.message) || JSON.stringify(_ctx.t0);
                    (0,API_error__WEBPACK_IMPORTED_MODULE_3__/* .handleError */ .S)(_ctx.t0, "API/houseApplication", "uploadCriminalReport");
                    throw new Error(errorMessage);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                6
            ]
        ]);
    }));
    return _uploadCriminalReport.apply(this, arguments);
}
function uploadEvictionReport(phoneNumber, buildiumUnitId, tenantData) {
    return _uploadEvictionReport.apply(this, arguments);
}
function _uploadEvictionReport() {
    _uploadEvictionReport = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(phoneNumber, buildiumUnitId, tenantData) {
        var url, ref, ref1, ref2, errorMessage;
        return _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    url = "".concat(BASE_PATH, "/upload-crs-eviction-report");
                    _ctx.next = 4;
                    return API__WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .h.post(url, {
                        tenantData: tenantData,
                        phoneNumber: phoneNumber,
                        buildiumUnitId: buildiumUnitId
                    });
                case 4:
                    _ctx.next = 12;
                    break;
                case 6:
                    _ctx.prev = 6;
                    _ctx.t0 = _ctx["catch"](0);
                    ;
                    errorMessage = (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.error) === null || ref2 === void 0 ? void 0 : ref2.message) || JSON.stringify(_ctx.t0);
                    (0,API_error__WEBPACK_IMPORTED_MODULE_3__/* .handleError */ .S)(_ctx.t0, "API/houseApplication", "uploadEvictionReport");
                    throw new Error(errorMessage);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                6
            ]
        ]);
    }));
    return _uploadEvictionReport.apply(this, arguments);
}


/***/ }),

/***/ 81195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CustomDateInput; }
});

// UNUSED EXPORTS: CustomDateInput

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/advancedFormat.js
var advancedFormat = __webpack_require__(28734);
var advancedFormat_default = /*#__PURE__*/__webpack_require__.n(advancedFormat);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./components/Icon/index.tsx
var Icon = __webpack_require__(11665);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js
var chakra_ui_system_esm = __webpack_require__(46052);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
;// CONCATENATED MODULE: ./components/CustomDateInput/customDateInput.styles.ts

var DatePickerWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: function() {
        return {
            border: "solid 1px",
            borderColor: "background.grey.200",
            paddingX: "1rem",
            paddingY: "8px",
            borderRadius: "6px",
            paddingBottom: "10px",
            justifyContent: "space-between",
            height: 10
        };
    }
});

;// CONCATENATED MODULE: ./components/CustomDateInput/index.tsx










dayjs_min_default().extend((advancedFormat_default()));
var CustomDateInput = function(props, ref) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DatePickerWrapper, {
        onClick: props === null || props === void 0 ? void 0 : props.onClick,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: ref,
                as: react_number_format_es/* default */.Z
            }, props), {
                variant: "unstyled",
                size: "sm",
                border: "none",
                fontSize: "md",
                format: "##/##/####",
                placeholder: "MM/DD/YYYY",
                mask: [
                    "M",
                    "M",
                    "D",
                    "D",
                    "Y",
                    "Y",
                    "Y",
                    "Y"
                ]
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                iconName: "date.svg",
                width: 20,
                height: 20
            })
        ]
    });
};
/* harmony default export */ var components_CustomDateInput = (CustomDateInput);


/***/ }),

/***/ 96519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomDaterRangePickerWithMask; }
});

// UNUSED EXPORTS: CustomDateRangePickerWithMask

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/advancedFormat.js
var advancedFormat = __webpack_require__(28734);
var advancedFormat_default = /*#__PURE__*/__webpack_require__.n(advancedFormat);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./components/Icon/index.tsx
var Icon = __webpack_require__(11665);
;// CONCATENATED MODULE: ./components/CustomDaterRangePickerWithMask/components/DateRangeInputWithMask/index.tsx







var DateRangeInputWithMask = function(props) {
    var onChange = function onChange(event) {
        var ref;
        var currentValue = event === null || event === void 0 ? void 0 : (ref = event.currentTarget) === null || ref === void 0 ? void 0 : ref.value;
        var ref1 = (0,_sliced_to_array/* default */.Z)(convertDateRangeValues(currentValue), 2), startDate = ref1[0], endDate = ref1[1];
        setInputValue(currentValue);
        // INFO: update form value and reset dateRangePicker
        if (startDate && endDate) {
            setValue(name, [
                startDate,
                endDate
            ]);
            setIsOpenCalendar(false);
        }
    };
    var convertDateRangeValues = function convertDateRangeValues(currentValue) {
        var ref = (0,_sliced_to_array/* default */.Z)(currentValue === null || currentValue === void 0 ? void 0 : currentValue.split("-"), 2), startDate = ref[0], endDate = ref[1];
        var dateRangeValues = [
            null,
            null
        ];
        if (dayjs_min_default()(startDate).isValid()) {
            dateRangeValues[0] = dayjs_min_default()(startDate).toDate();
        }
        if (dayjs_min_default()(endDate).isValid()) {
            dateRangeValues[1] = dayjs_min_default()(endDate).toDate();
        }
        return dateRangeValues;
    };
    var name = props.name, dateRangeInputValue = props.value, format = props.format, mask = props.mask, placeholder = props.placeholder, height = props.height, setIsOpenCalendar = props.setIsOpenCalendar, setValue = props.setValue, onClick = props.onClick;
    var ref = (0,react.useState)(), inputValue = ref[0], setInputValue = ref[1];
    (0,react.useEffect)(function() {
        if (dateRangeInputValue) {
            setInputValue(dateRangeInputValue);
        }
    }, [
        dateRangeInputValue
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_input_esm/* InputGroup */.BZ, {
        borderRadius: "6px",
        background: "white",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* InputRightElement */.xH, {
                pointerEvents: "none",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                    iconName: "date.svg",
                    width: 20,
                    height: 20
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, {
                as: react_number_format_es/* default */.Z,
                format: format,
                mask: mask,
                placeholder: placeholder,
                height: height,
                value: inputValue,
                autoComplete: "off",
                onClick: onClick,
                onChange: onChange
            })
        ]
    });
};
/* harmony default export */ var components_DateRangeInputWithMask = (DateRangeInputWithMask);

;// CONCATENATED MODULE: ./components/CustomDaterRangePickerWithMask/index.tsx








dayjs_min_default().extend((advancedFormat_default()));
var CustomDateRangePickerWithMask = function(props) {
    var handleOnChange = function handleOnChange(currentDateRangeValues) {
        onChange(currentDateRangeValues);
    };
    var field = props.field, name = props.name, inputMask = props.inputMask, inputFormat = props.inputFormat, inputPlaceholder = props.inputPlaceholder, dateFormat = props.dateFormat, setValue = props.setValue, height = props.height;
    var onChange = field.onChange, dateRangeValues = field.value;
    var ref = (0,react.useState)(null), startDate = ref[0], setStartDate = ref[1];
    var ref1 = (0,react.useState)(null), endDate = ref1[0], setEndDate = ref1[1];
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var pickerRef = (0,react.useRef)(null);
    var handleClickOutSide = (0,react.useCallback)(function(event) {
        var ref;
        if (!((ref = pickerRef.current) === null || ref === void 0 ? void 0 : ref.contains(event === null || event === void 0 ? void 0 : event.target)) && isOpen) {
            setIsOpen(false);
        }
    }, [
        isOpen,
        pickerRef
    ]);
    (0,react.useEffect)(function() {
        if (dateRangeValues) {
            var currentStartDate = dateRangeValues[0];
            var currentEndDate = dateRangeValues[1];
            setStartDate(currentStartDate);
            setEndDate(currentEndDate);
            if (currentStartDate && currentEndDate) {
                setIsOpen(false);
            }
        }
    }, [
        dateRangeValues
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("click", handleClickOutSide, true);
    }, [
        handleClickOutSide
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        ref: pickerRef,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((react_datepicker_min_default()), {
            selected: startDate,
            name: name,
            open: isOpen,
            onChange: handleOnChange,
            startDate: startDate,
            endDate: endDate,
            dateFormat: dateFormat,
            customInput: /*#__PURE__*/ (0,react.createElement)(function(param) {
                var value = param.value, onClick = param.onClick;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DateRangeInputWithMask, {
                    name: name,
                    value: value,
                    format: inputFormat,
                    mask: inputMask,
                    placeholder: inputPlaceholder,
                    height: height,
                    setIsOpenCalendar: setIsOpen,
                    setValue: setValue,
                    onClick: onClick
                });
            }),
            selectsRange: true,
            onInputClick: function() {
                setIsOpen(true);
            }
        })
    });
};
/* harmony default export */ var CustomDaterRangePickerWithMask = (CustomDateRangePickerWithMask);


/***/ }),

/***/ 78000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3789);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14257);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4612);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87536);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57333);
/* harmony import */ var components_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11665);
/* harmony import */ var constants_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88501);








var FormItemWithMask = function(props) {
    var id = props.id, name = props.name, label = props.label, type = props.type, format = props.format, mask = props.mask, placeholder = props.placeholder, prefix = props.prefix, suffix = props.suffix, thousandSeparator = props.thousandSeparator, defaultValue = props.defaultValue, onValueChange = props.onValueChange, _isSmallLabel = props.isSmallLabel, isSmallLabel = _isSmallLabel === void 0 ? false : _isSmallLabel, _isRequired = props.isRequired, isRequired = _isRequired === void 0 ? true : _isRequired, children = props.children, helperText = props.helperText, disabled = props.disabled, autoComplete = props.autoComplete, labelLineHeight = props.labelLineHeight, _isInHStack = props.isInHStack, isInHStack = _isInHStack === void 0 ? false : _isInHStack, height = props.height;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useFormContext */ .Gc)(), control = ref.control, errors = ref.formState.errors;
    var pattern;
    switch(name){
        case "ssn":
            //*INFO: validate ***-**-****
            pattern = {
                value: /^\d{3}-\d{2}-\d{4}$/,
                message: "Please enter a valid SSN"
            };
            break;
        case "dateOfBirth":
            //*INFO: validate (MM/DD/YYYY), with a year between 1900 and 2099
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .DATE_OF_BIRTH_PATTERN */ .Vo,
                message: "Please enter a valid date"
            };
            break;
        case "month":
            //*INFO: validate month: between 1 and 12
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .MONTH_PATTERN */ .c8,
                message: "Invalid month"
            };
            break;
        case "day":
            //*INFO: validate day: between 1 and 31
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .DAY_PATTERN */ .rq,
                message: "Invalid day"
            };
            break;
        case "year":
            //*INFO: validate year: between 1900 and 2099
            pattern = {
                value: constants_common__WEBPACK_IMPORTED_MODULE_4__/* .YEAR_PATTERN */ .H6,
                message: "Invalid year"
            };
            break;
        default:
            pattern = undefined;
    }
    var isSsn = name === "ssn";
    var disabledProps = disabled ? {
        disabled: true,
        background: "gray.100",
        opacity: "0.7 !important",
        color: "gray.400",
        variant: "filled"
    } : {};
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .FormControl */ .NI, {
        isInvalid: !!lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(errors, name, false),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .Ug, {
                marginTop: {
                    base: isSsn ? "18px" : "unset",
                    md: isSsn ? 2 : isInHStack ? 2 : "unset"
                },
                spacing: "14px",
                maxHeight: 6,
                marginBottom: {
                    base: isSsn ? "26px" : "unset",
                    md: isSsn ? 4 : "unset"
                },
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .FormLabel */ .lX, {
                        fontSize: isSmallLabel ? "sm" : "md",
                        color: isSmallLabel ? "gray.500" : "gray.700",
                        lineHeight: labelLineHeight !== null && labelLineHeight !== void 0 ? labelLineHeight : 5,
                        marginBottom: isInHStack ? 3 : 0,
                        marginInlineEnd: 0,
                        children: [
                            label,
                            name === "ssn" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                                href: "mailto:leasing@livehomeroom.com",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .Ug, {
                                    spacing: 2,
                                    flexWrap: "wrap",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .xv, {
                                        whiteSpace: {
                                            base: "unset",
                                            md: "nowrap"
                                        },
                                        children: "* For international SSN, please contact us at leasing@livehomeroom.com"
                                    })
                                })
                            })
                        ]
                    }),
                    helperText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Tooltip */ .u, {
                        label: helperText,
                        hasArrow: true,
                        placement: "right",
                        background: "gray.900",
                        color: "white",
                        fontSize: "sm",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                            textAlign: "center",
                            height: "20px",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(components_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                iconName: "information_line_blue.svg",
                                size: 20
                            })
                        })
                    })
                ]
            }),
            children ? children : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .Controller */ .Qr, {
                name: name,
                control: control,
                rules: {
                    required: isRequired ? "".concat(label, " is required") : false,
                    pattern: pattern
                },
                render: function(param) {
                    var _field = param.field, onChange = _field.onChange, onBlur = _field.onBlur, value = _field.value;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        height: height,
                        id: id,
                        as: react_number_format__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                        type: type,
                        value: value,
                        onBlur: onBlur,
                        onChange: onChange,
                        format: format,
                        mask: mask,
                        prefix: prefix,
                        suffix: suffix,
                        thousandSeparator: thousandSeparator,
                        defaultValue: defaultValue,
                        onValueChange: onValueChange,
                        autoComplete: autoComplete !== null && autoComplete !== void 0 ? autoComplete : name,
                        placeholder: placeholder
                    }, disabledProps));
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .FormErrorMessage */ .J1, {
                textAlign: "start",
                children: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(errors, "".concat(name, ".message"), "")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormItemWithMask);


/***/ }),

/***/ 409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MultiCarousel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/nuka-carousel/es-v5/carousel.js + 9 modules
var carousel = __webpack_require__(79574);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./enums/analytics/index.ts
var analytics = __webpack_require__(79251);
// EXTERNAL MODULE: ./components/Icon/index.tsx
var Icon = __webpack_require__(11665);
// EXTERNAL MODULE: ./utils/analytics.ts
var utils_analytics = __webpack_require__(26451);
;// CONCATENATED MODULE: ./components/MultiCarousel/components/ArrowControl/index.tsx








var Arrow = function(props) {
    var handleOnClick = function handleOnClick(event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        isNextArrow ? nextSlide() : previousSlide();
        (0,utils_analytics/* logEvent */.Kz)(analytics/* CategoryEnum.USER */.Bf.USER, isNextArrow ? analytics/* ActionEnum.CAROUSEL_NEXT_IMAGE_CLICKED */.Xv.CAROUSEL_NEXT_IMAGE_CLICKED : analytics/* ActionEnum.CAROUSEL_PREVIOUS_IMAGE_CLICKED */.Xv.CAROUSEL_PREVIOUS_IMAGE_CLICKED);
    };
    var type = props.type, slideCount = props.slideCount, previousSlide = props.previousSlide, nextSlide = props.nextSlide, setIsHovering = props.setIsHovering;
    var isNextArrow = type === "next";
    var iconName = isNextArrow ? "circle_right_arrow.svg" : "circle_left_arrow.svg";
    var arrowProps = isNextArrow ? {
        marginRight: "1.5rem"
    } : {
        marginLeft: "1.5rem"
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onMouseEnter: function() {
            return setIsHovering(true);
        },
        hidden: slideCount <= 1,
        cursor: "pointer"
    }, arrowProps), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
            iconName: iconName,
            onClick: handleOnClick,
            width: 40,
            height: 40
        })
    }));
};
/* harmony default export */ var ArrowControl = (Arrow);

;// CONCATENATED MODULE: ./components/MultiCarousel/components/DotIndicator/index.tsx



var DotIndicator = function(props) {
    var handleOnClick = function handleOnClick(event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        onClick();
    };
    var isDotSmall = props.isDotSmall, desktopDotMarginBottom = props.desktopDotMarginBottom, active = props.active, onClick = props.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        "data-testid": "dot-indicator",
        width: isDotSmall ? "8px" : {
            base: "8px",
            md: "16px"
        },
        height: isDotSmall ? "8px" : {
            base: "8px",
            md: "16px"
        },
        marginLeft: isDotSmall ? "3px" : {
            base: "3px",
            md: "8px"
        },
        marginRight: isDotSmall ? "3px" : {
            base: "3px",
            md: "8px"
        },
        marginBottom: desktopDotMarginBottom ? {
            base: "14px",
            lg: props.desktopDotMarginBottom
        } : "16px",
        backgroundColor: active ? "#fff" : "background.grey.500",
        rounded: "50%",
        display: "inline-block",
        transition: "background-color 0.6s ease",
        cursor: "pointer",
        _hover: {
            backgroundColor: "#fff"
        },
        _focus: {
            backgroundColor: "#fff"
        },
        _active: {
            backgroundColor: "#fff"
        },
        onClick: handleOnClick
    });
};
/* harmony default export */ var components_DotIndicator = (DotIndicator);

;// CONCATENATED MODULE: ./components/MultiCarousel/components/DotsControl/index.tsx




var DotsControl = function(props) {
    var currentSlide = props.currentSlide, slideCount = props.slideCount, desktopDotMarginBottom = props.desktopDotMarginBottom, isDotSmall = props.isDotSmall, hidden = props.hidden, goToSlide = props.goToSlide;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        hidden: slideCount <= 1 || hidden,
        children: Array.from(Array(slideCount).keys()).map(function(key) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DotIndicator, {
                active: currentSlide === key,
                isDotSmall: isDotSmall,
                desktopDotMarginBottom: desktopDotMarginBottom,
                onClick: function() {
                    goToSlide(key);
                }
            }, key);
        })
    });
};
/* harmony default export */ var components_DotsControl = (DotsControl);

// EXTERNAL MODULE: ./components/MultiCarousel/multiCarousel.module.scss
var multiCarousel_module = __webpack_require__(57156);
var multiCarousel_module_default = /*#__PURE__*/__webpack_require__.n(multiCarousel_module);
;// CONCATENATED MODULE: ./components/MultiCarousel/index.tsx








var MultiCarousel = function(props) {
    var slidesToShow = props.slidesToShow, slidesToScroll = props.slidesToScroll, cellSpacing = props.cellSpacing, _wrapAround = props.wrapAround, wrapAround = _wrapAround === void 0 ? true : _wrapAround, swiping = props.swiping, dragging = props.dragging, _showArrows = props.showArrows, showArrows = _showArrows === void 0 ? true : _showArrows, _showDots = props.showDots, showDots = _showDots === void 0 ? true : _showDots, _autoPlay = props.autoPlay, autoPlay = _autoPlay === void 0 ? false : _autoPlay, speed = props.speed, desktopDotMarginBottom = props.desktopDotMarginBottom, _isDotSmall = props.isDotSmall, isDotSmall = _isDotSmall === void 0 ? true : _isDotSmall, className = props.className, _setIsHovering = props.setIsHovering, setIsHovering = _setIsHovering === void 0 ? function() {} : _setIsHovering, children = props.children, innerRef = props.innerRef;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(carousel/* Carousel */.l, {
        innerRef: innerRef,
        className: className,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        cellSpacing: cellSpacing,
        swiping: swiping,
        wrapAround: wrapAround,
        dragging: dragging,
        autoplay: autoPlay,
        speed: speed,
        pauseOnHover: true,
        dragThreshold: 0.3,
        renderCenterLeftControls: function(controlProps) {
            if (!showArrows) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowControl, (0,_object_spread/* default */.Z)({
                setIsHovering: setIsHovering,
                type: "prev"
            }, controlProps));
        },
        renderCenterRightControls: function(controlProps) {
            if (!showArrows) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowControl, (0,_object_spread/* default */.Z)({
                setIsHovering: setIsHovering,
                type: "next"
            }, controlProps));
        },
        renderBottomCenterControls: function(controlProps) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DotsControl, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, controlProps), {
                desktopDotMarginBottom: desktopDotMarginBottom,
                isDotSmall: isDotSmall,
                hidden: !showDots
            }));
        },
        defaultControlsConfig: {
            containerClassName: (multiCarousel_module_default()).container
        },
        style: {
            overflowY: "unset"
        },
        children: children
    });
};
/* harmony default export */ var components_MultiCarousel = (MultiCarousel);


/***/ }),

/***/ 65798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ApplicationContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ApplicationContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 82120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bQ": function() { return /* binding */ BottomBackButton; },
/* harmony export */   "hz": function() { return /* binding */ ModalContent; },
/* harmony export */   "ol": function() { return /* binding */ CircleCloseButton; },
/* harmony export */   "x_": function() { return /* binding */ BottomButton; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46052);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28018);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85054);
/* harmony import */ var enums_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60431);


var CircleCloseButton = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .ModalCloseButton */ .ol, {
    baseStyle: function() {
        return {
            display: {
                base: "none",
                lg: "block"
            },
            borderRadius: "9999px",
            boxShadow: "base",
            marginTop: 10,
            marginRight: 10,
            translateY: "50%",
            background: "white !important",
            zIndex: enums_theme__WEBPACK_IMPORTED_MODULE_0__/* .EZIndexLayer.UPPER */ .qd.UPPER
        };
    }
});
var ModalContent = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .ModalContent */ .hz, {
    baseStyle: function() {
        return {
            position: "relative",
            borderRadius: "0px"
        };
    }
});
var BottomButton = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
    baseStyle: function() {
        return {
            paddingX: {
                base: 6,
                lg: 4
            },
            height: {
                base: "48px",
                lg: "40px"
            }
        };
    }
});
var BottomBackButton = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
    baseStyle: function() {
        return {
            paddingX: {
                base: 6,
                lg: 4
            },
            border: "1px solid #E2E8F0",
            height: {
                base: "48px",
                lg: "40px"
            },
            background: "white"
        };
    }
});


/***/ }),

/***/ 83049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CompleteScreeningContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var CompleteScreeningContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 53722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U1": function() { return /* reexport */ ECompleteScreeningSteps; },
  "Vk": function() { return /* reexport */ getCompleteScreeningSteps; },
  "US": function() { return /* reexport */ handleValidateFiles; },
  "TX": function() { return /* reexport */ shortenFileName; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/constant.ts
var constant = __webpack_require__(29166);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/chakra-ui-image.esm.js + 1 modules
var chakra_ui_image_esm = __webpack_require__(78428);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js
var mobxreact_esm = __webpack_require__(29323);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./theme/icon.tsx
var icon = __webpack_require__(99714);
// EXTERNAL MODULE: ./API/fileUploader/index.ts
var fileUploader = __webpack_require__(12281);
// EXTERNAL MODULE: ./components/Icon/index.tsx
var Icon = __webpack_require__(11665);
// EXTERNAL MODULE: ./components/pages/MyProfilePage/components/BackgroundInformation/components/UploadDriverLicense/constant.ts
var UploadDriverLicense_constant = __webpack_require__(88412);
// EXTERNAL MODULE: ./components/pages/MyProfilePage/myProfilePage.style.ts
var myProfilePage_style = __webpack_require__(28942);
// EXTERNAL MODULE: ./utils/common.ts
var common = __webpack_require__(6628);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/applicationForm.context.ts
var applicationForm_context = __webpack_require__(65798);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/completeScreening.context.ts
var completeScreening_context = __webpack_require__(83049);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/DriverLicense/index.tsx




















var DriverLicense = function() {
    var handleClickUploadFrontPhoto = function handleClickUploadFrontPhoto() {
        var currentRef = frontFilePickerRef.current || {
            click: function() {}
        };
        currentRef.click();
    };
    var handleClickUploadBackPhoto = function handleClickUploadBackPhoto() {
        var currentRef = backFilePickerRef.current || {
            click: function() {}
        };
        currentRef.click();
    };
    var isDriverLicenseVerified = (0,react.useContext)(applicationForm_context/* ApplicationContext */.Z).isDriverLicenseVerified;
    var ref = (0,react.useContext)(completeScreening_context/* CompleteScreeningContext */.T), setIsDriverLicenses = ref.setIsDriverLicenses, isDriverLicenses = ref.isDriverLicenses;
    var ref1 = (0,react.useState)(UploadDriverLicense_constant/* mockFrontPhoto */.L), frontPhoto = ref1[0], setFrontPhoto = ref1[1];
    var ref2 = (0,react.useState)(UploadDriverLicense_constant/* mockBackPhoto */.I), backPhoto = ref2[0], setBackPhoto = ref2[1];
    var ref3 = (0,react.useState)(false), isFrontLoading = ref3[0], setIsFrontLoading = ref3[1];
    var ref4 = (0,react.useState)(false), isBackLoading = ref4[0], setIsBackLoading = ref4[1];
    var ref5 = (0,index_esm/* useFormContext */.Gc)(), getValues = ref5.getValues, reset = ref5.reset;
    var formValue = getValues();
    var frontFilePickerRef = (0,react.useRef)(null);
    var backFilePickerRef = (0,react.useRef)(null);
    function handleUploadFile(event) {
        return _handleUploadFile.apply(this, arguments);
    }
    function _handleUploadFile() {
        _handleUploadFile = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var file, ref, heic2any, jpgFileBlob, jpgFile, imageUrl, imageUrl1, ref1, errorMessage, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        file = get_default()(event, "target.files.0", "");
                        ;
                        if (!(0,common/* isHeicFile */.ZP)((ref = file === null || file === void 0 ? void 0 : file.name) !== null && ref !== void 0 ? ref : "")) {
                            _ctx.next = 13;
                            break;
                        }
                        heic2any = __webpack_require__(1616);
                        _ctx.next = 7;
                        return heic2any({
                            blob: file,
                            toType: "image/jpeg"
                        });
                    case 7:
                        jpgFileBlob = _ctx.sent;
                        jpgFile = new File([
                            jpgFileBlob
                        ], "".concat(file.name.replace(/\.heic$/i, ""), ".jpg"), {
                            type: "image/jpeg"
                        });
                        _ctx.next = 11;
                        return (0,fileUploader/* uploadFile */.cT)(jpgFile);
                    case 11:
                        imageUrl = _ctx.sent;
                        return _ctx.abrupt("return", imageUrl);
                    case 13:
                        _ctx.next = 15;
                        return (0,fileUploader/* uploadFile */.cT)(file);
                    case 15:
                        imageUrl1 = _ctx.sent;
                        return _ctx.abrupt("return", imageUrl1);
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        errorMessage = "Upload image failed.";
                        if ((ref1 = _ctx.t0) === null || ref1 === void 0 ? void 0 : ref1.message) {
                            ;
                            errorMessage += " ".concat((ref2 = _ctx.t0) === null || ref2 === void 0 ? void 0 : ref2.message);
                        }
                        react_toastify_esm/* toast.error */.Am.error(errorMessage);
                        return _ctx.abrupt("return", "");
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    19
                ]
            ]);
        }));
        return _handleUploadFile.apply(this, arguments);
    }
    function handleFrontPhotoChange(event) {
        return _handleFrontPhotoChange.apply(this, arguments);
    }
    function _handleFrontPhotoChange() {
        _handleFrontPhotoChange = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var imageUrl, ref, errorMessage, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsFrontLoading(true);
                        _ctx.next = 4;
                        return handleUploadFile(event);
                    case 4:
                        imageUrl = _ctx.sent;
                        setFrontPhoto(imageUrl);
                        reset((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValue), {
                            driverLicenseFrontPhotoUrl: imageUrl
                        }));
                        if (backPhoto && backPhoto !== UploadDriverLicense_constant/* mockBackPhoto */.I) {
                            typeof setIsDriverLicenses === "function" && setIsDriverLicenses(true);
                        }
                        react_toastify_esm/* toast.success */.Am.success("Upload successfully!");
                        _ctx.next = 17;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        errorMessage = "Upload image failed.";
                        if ((ref = _ctx.t0) === null || ref === void 0 ? void 0 : ref.message) {
                            ;
                            errorMessage += " ".concat((ref1 = _ctx.t0) === null || ref1 === void 0 ? void 0 : ref1.message);
                        }
                        react_toastify_esm/* toast.error */.Am.error(errorMessage);
                    case 17:
                        _ctx.prev = 17;
                        setIsFrontLoading(false);
                        return _ctx.finish(17);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11,
                    17,
                    20
                ]
            ]);
        }));
        return _handleFrontPhotoChange.apply(this, arguments);
    }
    function handleBackPhotoChange(event) {
        return _handleBackPhotoChange.apply(this, arguments);
    }
    function _handleBackPhotoChange() {
        _handleBackPhotoChange = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var imageUrl, ref, errorMessage, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setIsBackLoading(true);
                        _ctx.next = 4;
                        return handleUploadFile(event);
                    case 4:
                        imageUrl = _ctx.sent;
                        setBackPhoto(imageUrl);
                        reset((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValue), {
                            driverLicenseBackPhotoUrl: imageUrl
                        }));
                        if (frontPhoto && frontPhoto !== UploadDriverLicense_constant/* mockFrontPhoto */.L) {
                            typeof setIsDriverLicenses === "function" && setIsDriverLicenses(true);
                        }
                        react_toastify_esm/* toast.success */.Am.success("Upload successfully!");
                        _ctx.next = 17;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        errorMessage = "Upload image failed.";
                        if ((ref = _ctx.t0) === null || ref === void 0 ? void 0 : ref.message) {
                            ;
                            errorMessage += " ".concat((ref1 = _ctx.t0) === null || ref1 === void 0 ? void 0 : ref1.message);
                        }
                        react_toastify_esm/* toast.error */.Am.error(errorMessage);
                    case 17:
                        _ctx.prev = 17;
                        setIsBackLoading(false);
                        return _ctx.finish(17);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11,
                    17,
                    20
                ]
            ]);
        }));
        return _handleBackPhotoChange.apply(this, arguments);
    }
    var ref6, ref7;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
        spacing: {
            md: 10,
            lg: isDriverLicenseVerified ? 2 : 12
        },
        marginBottom: {
            md: isDriverLicenseVerified ? 9 : "unset"
        },
        marginTop: {
            lg: isDriverLicenseVerified ? 2 : "calc(148px - 24px)"
        },
        height: "full",
        children: isDriverLicenseVerified && backPhoto === UploadDriverLicense_constant/* mockBackPhoto */.I ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
            maxWidth: {
                base: "full",
                md: constant/* DESKTOP_CONTAINER_WIDTH */.n2
            },
            marginX: "auto",
            minHeight: {
                base: "full",
                lg: "auto"
            },
            marginTop: {
                base: 8,
                lg: 40
            },
            spacing: 8,
            paddingX: 4,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                    iconName: "document_submitted.svg",
                    size: 64
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                    fontWeight: "500",
                    textAlign: "center",
                    textColor: "gray.700",
                    lineHeight: 6,
                    width: "full",
                    alignSelf: "center",
                    marginX: {
                        base: 4,
                        md: 0
                    },
                    children: "Your driver license photos were successfully uploaded."
                })
            ]
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
            width: "min(90vw, 500px)",
            height: "min(calc(100vh - 62px - 90px), 600px)",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                    fontWeight: {
                        base: 500,
                        lg: 600
                    },
                    textColor: "gray.700",
                    width: "full",
                    alignSelf: "center",
                    marginTop: 6,
                    marginBottom: {
                        base: 4,
                        lg: 6
                    },
                    children: "Photos of Driver License"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(myProfilePage_style/* RowWrapper */.eh, {
                    spacing: {
                        base: 6,
                        md: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(myProfilePage_style/* FormField */.Wi, {
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(myProfilePage_style/* FormLabel */.lX, {
                                    children: "Front Side"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, {
                                    type: "file",
                                    ref: frontFilePickerRef,
                                    display: "none",
                                    accept: ".svg, .png, .jpg, .jpeg",
                                    onChange: handleFrontPhotoChange
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Image */.Ee, {
                                    height: {
                                        base: "unset",
                                        md: "159px"
                                    },
                                    borderRadius: "8px",
                                    src: (ref6 = formValue === null || formValue === void 0 ? void 0 : formValue.driverLicenseFrontPhotoUrl) !== null && ref6 !== void 0 ? ref6 : frontPhoto,
                                    alt: "front-side",
                                    width: "full"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(myProfilePage_style/* UploadButton */.pF, {
                                    width: "full",
                                    onClick: handleClickUploadFrontPhoto,
                                    isLoading: isFrontLoading,
                                    iconSpacing: 2,
                                    leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon/* UploaderIcon */.R, {}),
                                    children: "Upload Photos"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(myProfilePage_style/* FormField */.Wi, {
                            spacing: 4,
                            marginBottom: {
                                base: "64px !important",
                                md: "unset"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(myProfilePage_style/* FormLabel */.lX, {
                                    children: "Back Side"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, {
                                    type: "file",
                                    ref: backFilePickerRef,
                                    display: "none",
                                    accept: ".svg, .png, .jpg, .jpeg",
                                    onChange: handleBackPhotoChange
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Image */.Ee, {
                                    height: {
                                        base: "unset",
                                        md: "159px"
                                    },
                                    borderRadius: "8px",
                                    src: (ref7 = formValue === null || formValue === void 0 ? void 0 : formValue.driverLicenseBackPhotoUrl) !== null && ref7 !== void 0 ? ref7 : backPhoto,
                                    alt: "back-side",
                                    width: "full"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(myProfilePage_style/* UploadButton */.pF, {
                                    width: "full",
                                    onClick: handleClickUploadBackPhoto,
                                    isLoading: isBackLoading,
                                    iconSpacing: 2,
                                    leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon/* UploaderIcon */.R, {}),
                                    children: "Upload Photos"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_DriverLicense = ((0,mobxreact_esm/* observer */.Pi)(DriverLicense));

// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 1 modules
var chakra_ui_button_esm = __webpack_require__(85054);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(86664);
// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/dist/stripe.esm.js
var stripe_esm = __webpack_require__(54465);
// EXTERNAL MODULE: ./enums/featureFlags/index.ts
var featureFlags = __webpack_require__(9322);
// EXTERNAL MODULE: ./hooks/useStores.ts
var useStores = __webpack_require__(19263);
// EXTERNAL MODULE: ./node_modules/react-unleash-flags/lib/index.js
var lib = __webpack_require__(68401);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(59876);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js
var chakra_ui_system_esm = __webpack_require__(46052);
// EXTERNAL MODULE: ./enums/common/index.ts
var enums_common = __webpack_require__(71074);
// EXTERNAL MODULE: ./enums/theme/index.ts
var theme = __webpack_require__(60431);
// EXTERNAL MODULE: ./hooks/useBreakPoint.ts
var useBreakPoint = __webpack_require__(41894);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./API/error.ts
var API_error = __webpack_require__(76214);
// EXTERNAL MODULE: ./API/houseApplication/index.ts
var houseApplication = __webpack_require__(55262);
// EXTERNAL MODULE: ./API/houseApplication/crs.ts
var crs = __webpack_require__(54166);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/applicationFormModalV2.styles.ts
var applicationFormModalV2_styles = __webpack_require__(82120);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/utils/index.ts + 16 modules
var utils = __webpack_require__(59362);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/CheckoutForm/components/CheckoutFormMainSection/index.tsx






var CheckoutFormMainSection = function(props) {
    var amount = props.amount, paymentRequest = props.paymentRequest;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        spacing: {
            base: 6,
            lg: 8
        },
        width: "stretch",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                alignSelf: "flex-start",
                fontSize: "md",
                fontWeight: "500",
                color: "gray.700",
                children: [
                    "We need to do a background check before continuing. You will be charged",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("b", {
                        children: [
                            " ".concat((0,common/* convertNumberToUSD */.gY)(amount)),
                            "."
                        ]
                    })
                ]
            }),
            paymentRequest && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_stripe_umd.PaymentRequestButtonElement, {
                        options: {
                            paymentRequest: paymentRequest
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                        minHeight: 10,
                        src: "/assets/images/divider.svg",
                        alt: "divider",
                        objectFit: "none",
                        objectPosition: "center"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Grid */.rj, {
                templateColumns: "repeat(4, 1fr)",
                gap: 2,
                width: "full",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* GridItem */.P4, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                            src: "/assets/images/card/visa.png",
                            alt: "Visa"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* GridItem */.P4, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                            src: "/assets/images/card/masterCard.png",
                            alt: "MasterCard"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* GridItem */.P4, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                            src: "/assets/images/card/americanExpress.png",
                            alt: "American Express"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* GridItem */.P4, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                            src: "/assets/images/card/discover.png",
                            alt: "Discover"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_stripe_umd.PaymentElement, {})
        ]
    });
};
/* harmony default export */ var components_CheckoutFormMainSection = ((0,mobxreact_esm/* observer */.Pi)(CheckoutFormMainSection));

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/CheckoutForm/components/PaymentSuccessful/index.tsx




var PaymentSuccessful = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        maxWidth: {
            base: "full",
            md: "500px"
        },
        marginX: "auto",
        minHeight: {
            base: "full",
            lg: "auto"
        },
        spacing: {
            base: 6,
            lg: 8
        },
        paddingX: 4,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                iconName: "payment_successful.svg",
                size: 64
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                textAlign: "center",
                fontWeight: "500",
                textColor: "gray.700",
                lineHeight: 6,
                width: "full",
                alignSelf: "center",
                marginX: 4,
                children: "Your payment method information was successfully updated."
            })
        ]
    });
};
/* harmony default export */ var components_PaymentSuccessful = (PaymentSuccessful);

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/CheckoutForm/constants.ts
var MIN_FICO_CREDIT_SCORE = 560;
var MIN_FICO_ENTIRE_HOUSE_CREDIT_SCORE = 600;
var EPaymentErrorType;
(function(EPaymentErrorType) {
    EPaymentErrorType["VALIDATION_ERROR"] = "validation_error";
})(EPaymentErrorType || (EPaymentErrorType = {}));

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/CheckoutForm/index.tsx




/* eslint-disable max-lines */ 


























var isProduction = "production" === enums_common/* EnvironmentEnum.PRODUCTION */.mf.PRODUCTION;
var CheckoutForm = function(props) {
    var isLoading = props.isLoading, setIsLoading = props.setIsLoading, setIsFailed = props.setIsFailed, amount = props.amount;
    var ref = (0,react.useContext)(applicationForm_context/* ApplicationContext */.Z), isBackLoading = ref.isBackLoading, handlePreviousStep = ref.handlePreviousStep, isPaymentSuccessful = ref.isPaymentSuccessful, setIsPaymentSuccessful = ref.setIsPaymentSuccessful, paymentClientSecret = ref.paymentClientSecret, setCompleteScreeningStep = ref.setCompleteScreeningStep;
    var nextStep = (0,react.useContext)(completeScreening_context/* CompleteScreeningContext */.T).nextStep;
    var stripe = (0,react_stripe_umd.useStripe)();
    var elements = (0,react_stripe_umd.useElements)();
    var getValues = (0,index_esm/* useFormContext */.Gc)().getValues;
    var crsCheckFeatureFlagName = "".concat("production", "-").concat(featureFlags/* default.WEBSITE_APPLICATION_FORM_CRS_CHECK */.Z.WEBSITE_APPLICATION_FORM_CRS_CHECK);
    var crsCheckFeatureFlag = (0,lib.useFlag)(crsCheckFeatureFlagName);
    var isEnableCRSCheckFeature = crsCheckFeatureFlag && (crsCheckFeatureFlag === null || crsCheckFeatureFlag === void 0 ? void 0 : crsCheckFeatureFlag.enabled);
    var ref1 = (0,react.useState)(null), paymentRequest = ref1[0], setPaymentRequest = ref1[1];
    var ref2 = (0,react.useState)(false), isReady = ref2[0], setIsReady = ref2[1];
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var isOverflow = (0,react_responsive.useMediaQuery)({
        maxHeight: isMobile ? 850 : 800
    }) && !isPaymentSuccessful;
    function checkBackgroundInformation() {
        return _checkBackgroundInformation.apply(this, arguments);
    }
    function _checkBackgroundInformation() {
        _checkBackgroundInformation = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var formValues, ref, creditScore, isValidCreditScore;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        formValues = getValues();
                        _ctx.next = 3;
                        return (0,crs/* authenticateCRS */.L_)();
                    case 3:
                        _ctx.t0 = _sliced_to_array/* default */.Z;
                        _ctx.next = 6;
                        return Promise.all([
                            (0,utils/* getCreditScore */.eI)(formValues),
                            (0,utils/* handleUploadCriminalReport */.Us)(formValues)
                        ]);
                    case 6:
                        _ctx.t1 = _ctx.sent;
                        ref = (0, _ctx.t0)(_ctx.t1, 1);
                        creditScore = ref[0];
                        isValidCreditScore = creditScore >= MIN_FICO_CREDIT_SCORE || !isEnableCRSCheckFeature || creditScore === 0;
                        if (!isValidCreditScore) {
                            setIsFailed(true);
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _checkBackgroundInformation.apply(this, arguments);
    }
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var confirmPaymentPromise, paymentIntentResult, _$error, paymentIntent, phoneNumber, status, errorType, errorMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        // We don't want to let default form submission happen here,
                        // which would refresh the page.
                        event.preventDefault();
                        event.stopPropagation();
                        if (!(!stripe || !elements)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        setIsLoading(true);
                        _ctx.prev = 5;
                        if (isPaymentSuccessful) {
                            _ctx.next = 27;
                            break;
                        }
                        confirmPaymentPromise = new Promise(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(resolve, reject) {
                                var paymentResponse;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return stripe.confirmPayment({
                                                //`Elements` instance that was used ko create the Payment Element
                                                elements: elements,
                                                redirect: "if_required"
                                            });
                                        case 2:
                                            paymentResponse = _ctx.sent;
                                            if (paymentResponse === null || paymentResponse === void 0 ? void 0 : paymentResponse.error) {
                                                reject(paymentResponse === null || paymentResponse === void 0 ? void 0 : paymentResponse.error);
                                            }
                                            resolve(paymentResponse);
                                        case 5:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(resolve, reject) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _ctx.next = 10;
                        return react_toastify_esm/* toast.promise */.Am.promise(confirmPaymentPromise, {
                            pending: "Your payment is processing.",
                            success: "Payment succeeded!"
                        });
                    case 10:
                        paymentIntentResult = _ctx.sent;
                        _$error = paymentIntentResult === null || paymentIntentResult === void 0 ? void 0 : paymentIntentResult.error;
                        if (!_$error) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 14:
                        if (!isEnableCRSCheckFeature) {
                            _ctx.next = 17;
                            break;
                        }
                        _ctx.next = 17;
                        return checkBackgroundInformation();
                    case 17:
                        paymentIntent = paymentIntentResult.paymentIntent;
                        if (!paymentIntent) {
                            _ctx.next = 23;
                            break;
                        }
                        phoneNumber = getValues("phoneNumber");
                        status = paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.status;
                        _ctx.next = 23;
                        return (0,houseApplication/* updatePaymentInfo */.sb)(phoneNumber, status, paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.id);
                    case 23:
                        typeof setIsPaymentSuccessful === "function" && setIsPaymentSuccessful(true);
                        nextStep();
                        _ctx.next = 28;
                        break;
                    case 27:
                        {
                            nextStep();
                            setIsLoading(false);
                        }
                    case 28:
                        typeof setCompleteScreeningStep === "function" && setCompleteScreeningStep(ECompleteScreeningSteps.DRIVER_LICENSE);
                        _ctx.next = 38;
                        break;
                    case 31:
                        _ctx.prev = 31;
                        _ctx.t0 = _ctx["catch"](5);
                        errorType = get_default()(_ctx.t0, "type", "") || JSON.stringify(_ctx.t0);
                        errorMessage = get_default()(_ctx.t0, "message", "Your payment was not successful, please try again");
                        if (!(errorType === EPaymentErrorType.VALIDATION_ERROR)) {
                            _ctx.next = 37;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 37:
                        react_toastify_esm/* toast.error */.Am.error(errorMessage);
                    case 38:
                        _ctx.prev = 38;
                        setIsLoading(false);
                        return _ctx.finish(38);
                    case 41:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    31,
                    38,
                    41
                ]
            ]);
        }));
        return function onSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!stripe) {
            return;
        }
        // *INFO: Amount using for testing will scale down 1:100
        var testingAmount = amount / 100;
        if (stripe) {
            var request = stripe.paymentRequest({
                country: "US",
                currency: "usd",
                total: {
                    label: "Apply Fee",
                    amount: isProduction ? (0,common/* convertUSDToCent */.X3)(amount) : (0,common/* convertUSDToCent */.X3)(testingAmount)
                },
                requestPayerName: true
            });
            // Check the availability of the Payment Request API.
            request.canMakePayment().then(function(result) {
                if (result) {
                    setPaymentRequest(request);
                }
            });
        }
    }, [
        stripe
    ]);
    (0,react.useEffect)(function() {
        if (elements) {
            var stripeElement = elements.getElement("payment");
            if (stripeElement) {
                stripeElement.on("ready", function() {
                    setIsReady(true);
                });
            }
            if (isPaymentSuccessful) {
                setIsReady(true);
            }
        }
    }, [
        elements
    ]);
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            if (stripe && elements && paymentClientSecret && !isPaymentSuccessful) {
                stripe.retrievePaymentIntent(paymentClientSecret).then(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                        var paymentIntent, phoneNumber;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    paymentIntent = param.paymentIntent;
                                    if (!(paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.status)) {
                                        _ctx.next = 5;
                                        break;
                                    }
                                    phoneNumber = getValues("phoneNumber");
                                    _ctx.next = 5;
                                    return (0,houseApplication/* updatePaymentInfo */.sb)(phoneNumber, paymentIntent.status, paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.id);
                                case 5:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }()).catch(function(error) {
                    (0,API_error/* handleError */.S)(error, "components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/CheckoutForm", "updatePaymentInformation");
                });
            }
        }, 15000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        stripe,
        elements
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_system_esm/* chakra.form */.m$.form, {
        width: "full",
        height: {
            base: "full",
            md: "unset"
        },
        onSubmit: onSubmit,
        display: "flex",
        flexDirection: "column",
        justifyContent: {
            base: "space-between",
            lg: "flex-start"
        },
        gap: 8,
        marginTop: {
            base: "2px",
            lg: 32
        },
        children: [
            !isPaymentSuccessful ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CheckoutFormMainSection, {
                amount: amount,
                paymentRequest: paymentRequest
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PaymentSuccessful, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                hidden: !isReady,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                    width: "full",
                    maxWidth: {
                        base: "full",
                        md: constant/* TABLET_CONTAINER_WIDTH */.u9,
                        lg: constant/* DESKTOP_CONTAINER_WIDTH */.n2
                    },
                    alignItems: "flex-end",
                    marginTop: {
                        md: isOverflow ? 0 : 5,
                        lg: "unset"
                    },
                    justifyContent: "space-between",
                    paddingX: {
                        base: isOverflow ? 0 : 4,
                        lg: "unset"
                    },
                    position: {
                        base: isOverflow ? "relative" : "absolute",
                        md: isOverflow ? "relative" : "absolute",
                        lg: "relative"
                    },
                    bottom: {
                        base: isOverflow ? -5 : 6,
                        md: isOverflow ? -5 : 12,
                        lg: "unset"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV2_styles/* BottomBackButton */.bQ, {
                            isLoading: isBackLoading,
                            onClick: handlePreviousStep,
                            variant: "solid",
                            children: constant/* EBottomButtonValue.BACK */.VF.BACK
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV2_styles/* BottomButton */.x_, {
                            colorScheme: "teal",
                            variant: "solid",
                            onClick: onSubmit,
                            bottom: "unset",
                            isLoading: isLoading || !stripe || !elements,
                            rightIcon: isPaymentSuccessful ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ArrowForwardIcon */.mr, {}) : undefined,
                            iconSpacing: isPaymentSuccessful ? 2 : undefined,
                            id: "submit",
                            children: isPaymentSuccessful ? "Continue" : "Pay ".concat((0,common/* convertNumberToUSD */.gY)(amount))
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_CheckoutForm = ((0,mobxreact_esm/* observer */.Pi)(CheckoutForm));

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/PaymentInformation/index.tsx














var PaymentInformation = function(param) {
    var amount = param.amount;
    var onClose = function onClose() {
        setIsFailed(false);
    };
    var ref = (0,react.useContext)(applicationForm_context/* ApplicationContext */.Z), clientSecret = ref.paymentClientSecret;
    var nextStep = (0,react.useContext)(completeScreening_context/* CompleteScreeningContext */.T).nextStep;
    var stripePromise = (0,stripe_esm/* loadStripe */.J)(constant/* STRIPE_PUBLISHABLE_KEY */.QZ);
    var houseApplicationStore = (0,useStores/* useStores */.m)().houseApplicationStore;
    var isTestPhoneNumber = houseApplicationStore.isTestPhoneNumber;
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isFailed = ref2[0], setIsFailed = ref2[1];
    var paymentFeatureFlagName = "".concat("production", "-").concat(featureFlags/* default.WEBSITE_APPLICATION_FORM_PAYMENT */.Z.WEBSITE_APPLICATION_FORM_PAYMENT);
    var paymentFeatureFlag = (0,lib.useFlag)(paymentFeatureFlagName);
    (0,react.useEffect)(function() {
        if (paymentFeatureFlag && !(paymentFeatureFlag === null || paymentFeatureFlag === void 0 ? void 0 : paymentFeatureFlag.enabled) && isTestPhoneNumber) {
            nextStep();
        }
    }, [
        paymentFeatureFlag
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        maxWidth: {
            base: "full",
            md: "736px",
            lg: "500px"
        },
        marginX: "auto",
        minHeight: {
            base: "full",
            lg: "100vh"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                spacing: 6,
                position: "absolute",
                top: "50%",
                transform: "translate(-50%, -50%)",
                justifyContent: "center",
                hidden: !isLoading,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                        src: "/assets/icons/loading_animated.svg",
                        alt: "loading"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "md",
                        fontWeight: "500",
                        color: "gray.700",
                        children: "Loading, please wait."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                position: "absolute",
                top: "50%",
                transform: "translate(-50%, -50%)",
                justifyContent: "center",
                hidden: !isFailed || isLoading,
                width: "100%",
                paddingX: 6,
                spacing: 8,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                        spacing: {
                            base: 4,
                            lg: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                                src: "/assets/images/sad.png",
                                alt: "failed"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                width: {
                                    base: "100%",
                                    md: "360px"
                                },
                                textAlign: "center",
                                fontSize: "md",
                                fontWeight: "500",
                                color: "gray.700",
                                children: "Unfortunately, you didn\u2019t meet the minimum credit score required to join Homeroom at this time."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                        display: {
                            base: "none",
                            lg: "inline-flex"
                        },
                        height: {
                            base: "48px",
                            lg: "40px"
                        },
                        marginTop: 2,
                        colorScheme: "teal",
                        color: "white",
                        boxShadow: "base",
                        variant: "solid",
                        minWidth: "200px",
                        onClick: onClose,
                        children: "Close"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                paddingX: 4,
                paddingY: {
                    base: 6,
                    lg: 8
                },
                height: {
                    base: "full",
                    md: "unset"
                },
                hidden: isLoading || isFailed || !clientSecret,
                children: clientSecret && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_stripe_umd.Elements, {
                    stripe: stripePromise,
                    options: {
                        clientSecret: clientSecret,
                        appearance: {
                            theme: "stripe"
                        }
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CheckoutForm, {
                        isLoading: isLoading,
                        amount: amount,
                        setIsLoading: setIsLoading,
                        setIsFailed: setIsFailed
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_PaymentInformation = ((0,mobxreact_esm/* observer */.Pi)(PaymentInformation));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(10894);
// EXTERNAL MODULE: ./node_modules/lodash/set.js
var set = __webpack_require__(36968);
var set_default = /*#__PURE__*/__webpack_require__.n(set);
// EXTERNAL MODULE: ./components/CustomDaterRangePickerWithMask/index.tsx + 1 modules
var CustomDaterRangePickerWithMask = __webpack_require__(96519);
// EXTERNAL MODULE: ./components/FormInput/index.tsx
var FormInput = __webpack_require__(10150);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./constants/common.ts
var constants_common = __webpack_require__(88501);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/LandlordPhoneInput/index.tsx







var LandlordPhoneInput = function() {
    var onPastePhoneInput = function onPastePhoneInput(event) {
        var clipboardData = event.clipboardData;
        var pastedPhoneNumber = clipboardData.getData("Text").replace(/\n/g, "");
        if (pastedPhoneNumber.startsWith("+1")) {
            var phoneNumber = (0,common/* formatUSPhoneNumber */.uX)(pastedPhoneNumber);
            reset({
                phoneNumber: phoneNumber
            });
        }
    };
    var ref = (0,index_esm/* useFormContext */.Gc)(), control = ref.control, reset = ref.reset;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
            name: "previousLandlordPhoneNumber",
            control: control,
            rules: {
                required: "Landlord Phone Number is required",
                pattern: {
                    value: constants_common/* RAW_PHONE_NUMBER_PATTERN */.kc,
                    message: "Please enter a valid phone number"
                }
            },
            render: function(param) {
                var _field = param.field, onChange = _field.onChange, value = _field.value;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, {
                    as: react_number_format_es/* default */.Z,
                    value: value,
                    onChange: onChange,
                    format: "(###) ###-####",
                    placeholder: "Enter Landlord phone number",
                    marginTop: "0 !important",
                    height: {
                        base: "48px",
                        lg: "40px"
                    },
                    fontSize: {
                        base: "lg",
                        lg: "md"
                    },
                    onPaste: onPastePhoneInput
                });
            }
        })
    });
};
/* harmony default export */ var components_LandlordPhoneInput = (LandlordPhoneInput);

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/PreviousLandlordInformation/index.tsx










var PICKER_DATE_FORMAT = "MM/dd/yyyy";
var DATE_INPUT_FORMAT = "##/##/#### - ##/##/####";
var DATE_INPUT_MASK = [
    "M",
    "M",
    "D",
    "D",
    "Y",
    "Y",
    "Y",
    "Y",
    "M",
    "M",
    "D",
    "D",
    "Y",
    "Y",
    "Y",
    "Y"
];
var PreviousLandlordInformation = function() {
    var ref = (0,index_esm/* useFormContext */.Gc)(), control = ref.control, setValue = ref.setValue;
    var isNotDesktop = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.LG */.yE.LG);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        width: "full",
        spacing: 4,
        alignItems: "flex-start",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                fontWeight: 600,
                color: "gray.700",
                children: "Previous Landlord Information"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                width: "full",
                spacing: 8,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                        height: isNotDesktop ? "48px" : "40px",
                        name: "previousLandlordName",
                        label: "Landlord Name / Company Name",
                        placeholder: "Enter Landlord Name / Company Name",
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                        name: "previousLandlordPhoneNumber",
                        label: "Landlord Phone Number",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LandlordPhoneInput, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                        height: isNotDesktop ? "48px" : "40px",
                        name: "previousLandlordEmail",
                        label: "Landlord Email Address (optional)",
                        placeholder: "Enter Landlord email address",
                        type: "email",
                        autoComplete: "off",
                        isRequired: false
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                        name: "previousMoveDate",
                        label: "Move-in - Move-out date (optional)",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
                            name: "previousMoveDate",
                            control: control,
                            render: function(previousMoveDateProps) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomDaterRangePickerWithMask/* default */.Z, (0,_object_spread/* default */.Z)({
                                    name: "previousMoveDate",
                                    dateFormat: PICKER_DATE_FORMAT,
                                    inputFormat: DATE_INPUT_FORMAT,
                                    inputMask: DATE_INPUT_MASK,
                                    inputPlaceholder: "__/__/____ - __/__/____",
                                    height: isNotDesktop ? "48px" : "40px",
                                    setValue: setValue
                                }, previousMoveDateProps));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_PreviousLandlordInformation = (PreviousLandlordInformation);

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/PaystubUpload/utils.ts

function validatePaystubStep(formValue) {
    if ((formValue === null || formValue === void 0 ? void 0 : formValue.previousLandlordPhoneNumber) && (formValue === null || formValue === void 0 ? void 0 : formValue.previousLandlordName)) {
        var isValidPhoneNumber = constants_common/* RAW_PHONE_NUMBER_PATTERN.test */.kc.test(formValue.previousLandlordPhoneNumber);
        var isValidName = constants_common/* NAME_WITH_NUMBER_PATTERN.test */.Jp.test(formValue.previousLandlordName);
        var isValidEmail = (formValue === null || formValue === void 0 ? void 0 : formValue.previousLandlordEmail) ? constants_common/* EMAIL_PATTERN.test */.QI.test(formValue.previousLandlordEmail) : true;
        return isValidPhoneNumber && isValidName && isValidEmail;
    }
    return false;
}

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/PaystubUpload/index.tsx




/* eslint-disable max-lines */ 





















var PayStubUpload = function(props) {
    var handleClickUpload = function handleClickUpload() {
        var currentRef = filePickerRef.current || {
            click: function() {}
        };
        currentRef.click();
    };
    var handleSubmit = function handleSubmit() {
        if ((0,common/* getValidArray */._b)(fileList).length < constant/* PAYSTUBS_REQUIRED_QUANTITY */.Kk) {
            (0,utils/* notifyPaystubsRequiredQuantity */.I6)();
        } else if (validatePaystubStep(formData)) {
            typeof nextStep === "function" && nextStep();
        } else {
            trigger([
                "previousLandlordName",
                "previousLandlordPhoneNumber"
            ]);
        }
    };
    var clearCurrentValue = function clearCurrentValue() {
        set_default()(filePickerRef, "current.value", "");
    };
    var deleteFile = function deleteFile(index) {
        var newFileList = (0,common/* getValidArray */._b)(fileList).filter(function(_, i) {
            return i !== index;
        });
        setFileList(newFileList);
    };
    var paystubFiles = props.paystubFiles;
    var filePickerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)([]), fileList = ref[0], setFileList = ref[1];
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), setValue = ref1.setValue, getValues = ref1.getValues, trigger = ref1.trigger;
    var formData = getValues();
    var ref2 = (0,react.useContext)(applicationForm_context/* ApplicationContext */.Z), setIsLoading = ref2.setIsLoading, setIsBackLoading = ref2.setIsBackLoading, isLoading = ref2.isLoading, isBackLoading = ref2.isBackLoading, nextStep = ref2.nextStep;
    var handlePreviousStep = (0,react.useContext)(completeScreening_context/* CompleteScreeningContext */.T).handlePreviousStep;
    (0,react.useEffect)(function() {
        setValue("paystubFiles", fileList);
    }, [
        fileList
    ]);
    (0,react.useEffect)(function() {
        if ((0,common/* getValidArray */._b)(paystubFiles).length > 0) {
            setFileList(paystubFiles);
        }
    }, [
        paystubFiles
    ]);
    function handleUploadFile(file) {
        return _handleUploadFile.apply(this, arguments);
    }
    function _handleUploadFile() {
        _handleUploadFile = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(file) {
            var ref, heic2any, jpgFileBlob, jpgFile, imageUrl, imageUrl1, ref1, errorMessage, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        if (!(0,common/* isHeicFile */.ZP)((ref = file === null || file === void 0 ? void 0 : file.name) !== null && ref !== void 0 ? ref : "")) {
                            _ctx.next = 12;
                            break;
                        }
                        heic2any = __webpack_require__(1616);
                        _ctx.next = 6;
                        return heic2any({
                            blob: file,
                            toType: "image/jpeg"
                        });
                    case 6:
                        jpgFileBlob = _ctx.sent;
                        jpgFile = new File([
                            jpgFileBlob
                        ], "".concat(file.name.replace(/\.heic$/i, ""), ".jpg"), {
                            type: "image/jpeg"
                        });
                        _ctx.next = 10;
                        return (0,fileUploader/* uploadFile */.cT)(jpgFile);
                    case 10:
                        imageUrl = _ctx.sent;
                        return _ctx.abrupt("return", imageUrl);
                    case 12:
                        _ctx.next = 14;
                        return (0,fileUploader/* uploadFile */.cT)(file);
                    case 14:
                        imageUrl1 = _ctx.sent;
                        return _ctx.abrupt("return", imageUrl1);
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        errorMessage = "Upload image failed.";
                        if ((ref1 = _ctx.t0) === null || ref1 === void 0 ? void 0 : ref1.message) {
                            ;
                            errorMessage += " ".concat((ref2 = _ctx.t0) === null || ref2 === void 0 ? void 0 : ref2.message);
                        }
                        react_toastify_esm/* toast.error */.Am.error(errorMessage);
                        return _ctx.abrupt("return", "");
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18
                ]
            ]);
        }));
        return _handleUploadFile.apply(this, arguments);
    }
    function handleChangeFile(event) {
        return _handleChangeFile.apply(this, arguments);
    }
    function _handleChangeFile() {
        _handleChangeFile = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var files, fileArray, result, filteredResult, errorMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        typeof setIsLoading === "function" && setIsLoading(true);
                        typeof setIsBackLoading === "function" && setIsBackLoading(true);
                        files = get_default()(event, "target.files") || [];
                        fileArray = handleValidateFiles(files);
                        _ctx.next = 7;
                        return Promise.all((0,common/* getValidArray */._b)(fileArray).map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(file) {
                                var response;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (file === null || file === void 0 ? void 0 : file.name) {
                                                _ctx.next = 2;
                                                break;
                                            }
                                            return _ctx.abrupt("return", "");
                                        case 2:
                                            _ctx.next = 4;
                                            return handleUploadFile(file);
                                        case 4:
                                            response = _ctx.sent;
                                            return _ctx.abrupt("return", response);
                                        case 6:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(file) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                    case 7:
                        result = _ctx.sent;
                        filteredResult = result.filter(function(item) {
                            return !!item;
                        });
                        setFileList((0,_to_consumable_array/* default */.Z)(fileList).concat((0,_to_consumable_array/* default */.Z)(filteredResult)));
                        clearCurrentValue();
                        if (filteredResult.length > 0) {
                            react_toastify_esm/* toast.success */.Am.success("Upload document successfully!");
                        }
                        _ctx.next = 19;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](0);
                        errorMessage = get_default()(_ctx.t0, "message", "Something went wrong!");
                        react_toastify_esm/* toast.error */.Am.error(errorMessage);
                        (0,API_error/* handleError */.S)(_ctx.t0, "./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/components/PaystubUpload", "handleChangeFile");
                    case 19:
                        _ctx.prev = 19;
                        typeof setIsLoading === "function" && setIsLoading(false);
                        typeof setIsBackLoading === "function" && setIsBackLoading(false);
                        return _ctx.finish(19);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    14,
                    19,
                    23
                ]
            ]);
        }));
        return _handleChangeFile.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        spacing: 8,
        alignItems: {
            base: "flex-start",
            lg: "center"
        },
        width: "full",
        height: "full",
        marginBottom: {
            base: 20,
            lg: "auto"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                maxWidth: {
                    base: "full",
                    lg: constant/* DESKTOP_CONTAINER_WIDTH */.n2
                },
                marginX: "auto",
                minHeight: {
                    base: "full",
                    md: "auto",
                    lg: "auto"
                },
                paddingTop: {
                    base: 6,
                    lg: 40
                },
                spacing: 8,
                paddingX: 4,
                alignItems: "flex-start",
                width: "full",
                height: "full",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                        spacing: 4,
                        alignItems: "flex-start",
                        width: "full",
                        paddingBottom: {
                            lg: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                                fontSize: "md",
                                fontWeight: "500",
                                color: "gray.700",
                                children: [
                                    "Please upload ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("b", {
                                        children: [
                                            "at least ",
                                            constant/* PAYSTUBS_REQUIRED_QUANTITY */.Kk
                                        ]
                                    }),
                                    " of your most recent pay stubs or bank statements."
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                                spacing: 4,
                                alignItems: "flex-start",
                                width: "full",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                                        flexDirection: "row",
                                        iconSpacing: 2,
                                        leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon/* UploaderIcon */.R, {}),
                                        variant: "outline",
                                        onClick: handleClickUpload,
                                        fontSize: {
                                            base: "lg",
                                            lg: "md"
                                        },
                                        lineHeight: {
                                            base: 7,
                                            lg: 6
                                        },
                                        width: "full",
                                        height: {
                                            base: 12,
                                            lg: "44px"
                                        },
                                        color: "gray.700",
                                        justifyContent: {
                                            base: "center",
                                            lg: "flex-start"
                                        },
                                        borderRadius: "6px",
                                        isLoading: isLoading,
                                        children: "Upload Files"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, {
                                        type: "file",
                                        ref: filePickerRef,
                                        onChange: handleChangeFile,
                                        display: "none",
                                        accept: ".svg, .png, .jpg, .jpeg, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv, .doc, .docx, image/heic, image/heif, image/heif-sequence, image/heic-sequence, image/avif",
                                        multiple: true
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                                        spacing: 4,
                                        alignItems: "flex-start",
                                        width: "full",
                                        marginBottom: {
                                            lg: 0
                                        },
                                        children: (0,common/* getValidArray */._b)(fileList).map(function(file, index) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                                                height: {
                                                    base: 10
                                                },
                                                alignItems: "flex-start",
                                                spacing: 0,
                                                border: "1px solid #319795",
                                                justifyContent: "center",
                                                borderRadius: "4px",
                                                position: "relative",
                                                width: {
                                                    base: "full"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                    paddingX: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                                            fontSize: "xs",
                                                            fontWeight: 500,
                                                            lineHeight: 4,
                                                            color: "gray.700",
                                                            marginBottom: {
                                                                lg: 0
                                                            },
                                                            children: shortenFileName(file, 30)
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                                            spacing: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                                                                    width: 6,
                                                                    height: 6,
                                                                    minWidth: 6,
                                                                    padding: 0,
                                                                    borderRadius: "50%",
                                                                    background: "teal.500",
                                                                    cursor: "default",
                                                                    _hover: {
                                                                        bg: "teal.500"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icon_esm/* Icon */.JO, {
                                                                        as: chakra_ui_icons_esm/* CheckIcon */.nQ,
                                                                        width: 2,
                                                                        height: 2,
                                                                        color: "white"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* Button */.zx, {
                                                                    width: 6,
                                                                    height: 6,
                                                                    minWidth: 6,
                                                                    padding: 0,
                                                                    borderRadius: "50%",
                                                                    background: "gray.100",
                                                                    cursor: "pointer",
                                                                    onClick: function() {
                                                                        return deleteFile(index);
                                                                    },
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                        iconName: "trash.svg",
                                                                        size: 20
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, file);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PreviousLandlordInformation, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                width: "full",
                maxWidth: {
                    base: "full",
                    lg: constant/* DESKTOP_CONTAINER_WIDTH */.n2
                },
                height: "auto",
                alignItems: "center",
                justifyContent: "space-between",
                spacing: 2,
                paddingBottom: {
                    base: 6,
                    md: 12,
                    lg: "auto"
                },
                paddingTop: {
                    base: 4,
                    lg: "34px"
                },
                position: {
                    base: "fixed",
                    lg: "relative"
                },
                bottom: {
                    base: 0,
                    lg: "auto"
                },
                marginTop: {
                    base: "auto",
                    lg: "0px !important"
                },
                zIndex: theme/* EZIndexLayer.MODAL */.qd.MODAL,
                paddingX: 4,
                backgroundColor: {
                    base: "white",
                    lg: "none"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV2_styles/* BottomBackButton */.bQ, {
                        isLoading: isBackLoading,
                        onClick: handlePreviousStep,
                        variant: "solid",
                        children: constant/* EBottomButtonValue.BACK */.VF.BACK
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV2_styles/* BottomButton */.x_, {
                        colorScheme: "teal",
                        variant: "solid",
                        iconSpacing: 2,
                        onClick: handleSubmit,
                        isLoading: isLoading,
                        rightIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* CheckIcon */.nQ, {}),
                        children: constant/* EBottomButtonValue.SUBMIT */.VF.SUBMIT
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PaystubUpload = (PayStubUpload);

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/utils/handleSteps.tsx






var ECompleteScreeningSteps;
(function(ECompleteScreeningSteps) {
    ECompleteScreeningSteps[ECompleteScreeningSteps["PAYMENT_INFORMATION"] = 0] = "PAYMENT_INFORMATION";
    ECompleteScreeningSteps[ECompleteScreeningSteps["DRIVER_LICENSE"] = 1] = "DRIVER_LICENSE";
    ECompleteScreeningSteps[ECompleteScreeningSteps["PAYSTUB_UPLOADER"] = 2] = "PAYSTUB_UPLOADER";
})(ECompleteScreeningSteps || (ECompleteScreeningSteps = {}));
function getCompleteScreeningSteps(paystubFiles) {
    return [
        {
            label: ECompleteScreeningSteps.PAYMENT_INFORMATION,
            content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PaymentInformation, {
                amount: constant/* APPLICATION_FEE */.cX
            })
        },
        {
            label: ECompleteScreeningSteps.DRIVER_LICENSE,
            content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DriverLicense, {})
        },
        {
            label: ECompleteScreeningSteps.PAYSTUB_UPLOADER,
            content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaystubUpload, {
                paystubFiles: paystubFiles
            })
        }
    ];
}

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/utils/upload.ts
function handleValidateFiles(files) {
    var validFiles = Array.from(files).map(function(file) {
        // if (file?.name?.includes('—')) {
        //   toast.error(`File name: ${file?.name} is not valid!`)
        //   clearCurrentValue()
        //   return {} as File
        // }
        // if (!file?.type.includes('image')) {
        //   toast.error(`${file?.name} is not an image file!`)
        //   clearCurrentValue()
        //   return {} as File
        // }
        return file;
    });
    return validFiles;
}
function shortenFileName(fileUrl, length) {
    var fileNameFromAWS = (fileUrl !== null && fileUrl !== void 0 ? fileUrl : "").split("/")[3];
    var fileName = (fileNameFromAWS !== null && fileNameFromAWS !== void 0 ? fileNameFromAWS : "").split("_").slice(1).join("_");
    if ((fileName === null || fileName === void 0 ? void 0 : fileName.length) > length) {
        return fileName.slice(0, length) + "...";
    }
    return fileName;
}

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/utils/index.ts




/***/ }),

/***/ 29166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C9": function() { return /* binding */ TEST_CRS_CRIMINAL_MOCK_DATA; },
/* harmony export */   "Kk": function() { return /* binding */ PAYSTUBS_REQUIRED_QUANTITY; },
/* harmony export */   "O$": function() { return /* binding */ EDriverLicenseTypeEnum; },
/* harmony export */   "P5": function() { return /* binding */ EApplicationCompletedStateV2; },
/* harmony export */   "QZ": function() { return /* binding */ STRIPE_PUBLISHABLE_KEY; },
/* harmony export */   "Qw": function() { return /* binding */ APPLICATION_TEST_FEE; },
/* harmony export */   "Uq": function() { return /* binding */ TEST_CRS_CREDIT_SCORE_MOCK_DATA; },
/* harmony export */   "VF": function() { return /* binding */ EBottomButtonValue; },
/* harmony export */   "X0": function() { return /* binding */ EApplicationStepBar; },
/* harmony export */   "_G": function() { return /* binding */ TEST_CRS_EVICTION_MOCK_DATA; },
/* harmony export */   "cX": function() { return /* binding */ APPLICATION_FEE; },
/* harmony export */   "fU": function() { return /* binding */ refererSource; },
/* harmony export */   "fh": function() { return /* binding */ TEST_CRS_EMAIL_SUB; },
/* harmony export */   "n2": function() { return /* binding */ DESKTOP_CONTAINER_WIDTH; },
/* harmony export */   "u9": function() { return /* binding */ TABLET_CONTAINER_WIDTH; }
/* harmony export */ });
/* unused harmony exports DOCUSIGN_LOADING_PAGE_URL, SECURITY_DEPOSIT */
var STRIPE_PUBLISHABLE_KEY = "pk_live_51L2eFOKWNOHUbCIwy4bktsK1r9WY7x8oSMAUlHAJ7Rb6nYTaufYoRImrjIB1tPKs6QXSf6plE2Ki1nULNdSNmfUe00kPVhK5ry";
var refererSource = [
    "Apartments.com",
    "Craigslist",
    "Facebook Group",
    "Facebook Marketplace",
    "Facebook Ad",
    "Livehomeroom.com",
    "Realtor.com",
    "RentPath",
    "Roomster",
    "Zumper",
    "Other"
];
var EApplicationStepBar;
(function(EApplicationStepBar) {
    EApplicationStepBar[EApplicationStepBar["DO_YOU_QUALIFY"] = 0] = "DO_YOU_QUALIFY";
    EApplicationStepBar[EApplicationStepBar["SHARE_YOUR_DEETS"] = 1] = "SHARE_YOUR_DEETS";
    EApplicationStepBar[EApplicationStepBar["COMPLETE_SCREENING"] = 2] = "COMPLETE_SCREENING";
    EApplicationStepBar[EApplicationStepBar["COMPLETED"] = 3] = "COMPLETED";
})(EApplicationStepBar || (EApplicationStepBar = {}));
var EApplicationCompletedStateV2;
(function(EApplicationCompletedStateV2) {
    EApplicationCompletedStateV2["PHONE_NUMBER_SUBMITTED"] = "Phone number submitted";
    EApplicationCompletedStateV2["OTP_VERIFIED"] = "OTP verified";
    EApplicationCompletedStateV2["BASIC_INFORMATION_SUBMITTED"] = "Basic information submitted";
    EApplicationCompletedStateV2["SHARE_YOUR_DEETS_SUBMITTED"] = "Background information and most recent address submitted";
    EApplicationCompletedStateV2["COMPLETE_SCREENING_SUBMITTED"] = "Drivers license, fee payment and paystub uploader submitted";
    EApplicationCompletedStateV2["FULL_APPLICATION_COMPLETED"] = "Full application completed";
    EApplicationCompletedStateV2["BLANK"] = "";
})(EApplicationCompletedStateV2 || (EApplicationCompletedStateV2 = {}));
var EDriverLicenseTypeEnum;
(function(EDriverLicenseTypeEnum) {
    EDriverLicenseTypeEnum["ACCEPT"] = "accept";
    EDriverLicenseTypeEnum["REVIEW"] = "review";
    EDriverLicenseTypeEnum["REJECT"] = "reject";
})(EDriverLicenseTypeEnum || (EDriverLicenseTypeEnum = {}));
var EBottomButtonValue;
(function(EBottomButtonValue) {
    EBottomButtonValue["BACK"] = "Back";
    EBottomButtonValue["CONTINUE"] = "Continue";
    EBottomButtonValue["SUBMIT"] = "Submit Application";
    EBottomButtonValue["COMPLETE"] = "Complete";
})(EBottomButtonValue || (EBottomButtonValue = {}));
var DESKTOP_CONTAINER_WIDTH = "500px";
var TABLET_CONTAINER_WIDTH = "736px";
// INFO: mock data using for testing CRS check on SandBox
var TEST_CRS_EMAIL_SUB = ".test-crs@yopmail.com";
var TEST_CRS_CREDIT_SCORE_MOCK_DATA = {
    firstName: "daisy",
    lastName: "oogrd",
    ssn: "666268141",
    dob: "1969-01-27",
    city: "HONOLULU",
    state: "HI",
    phone: "0000000000"
};
var TEST_CRS_CRIMINAL_MOCK_DATA = {
    last: "Consumer",
    first: "Jonathan",
    dob: "01-01-1982",
    ssn: "666-44-3321",
    city: "Cottonwood",
    state: "CA",
    zip: "91502"
};
var TEST_CRS_EVICTION_MOCK_DATA = {
    last: "Consumer",
    first: "Jonathan",
    dob: "01-01-1982",
    ssn: "666-44-3321",
    houseNumber: "1803",
    streetName: "Norma",
    city: "Cottonwood",
    state: "CA",
    zip: "91502"
};
var DOCUSIGN_LOADING_PAGE_URL = "".concat("https://app.livehomeroom.com", "/docusign-loading");
var SECURITY_DEPOSIT = 350;
var APPLICATION_FEE = 35;
var APPLICATION_TEST_FEE = 0.5;
var PAYSTUBS_REQUIRED_QUANTITY = 3;


/***/ }),

/***/ 59362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hp": function() { return /* reexport */ checkValidDayOfMonth; },
  "M6": function() { return /* reexport */ fetchClientSecret; },
  "$n": function() { return /* reexport */ getApplicationSteps; },
  "mp": function() { return /* reexport */ getContinueApplyingStep; },
  "eI": function() { return /* reexport */ getCreditScore; },
  "lu": function() { return /* reexport */ getNewCompletedState; },
  "AF": function() { return /* reexport */ getReferrers; },
  "Us": function() { return /* reexport */ handleUploadCriminalReport; },
  "Ds": function() { return /* reexport */ handleUploadEvectionReport; },
  "ed": function() { return /* reexport */ logStepToAmplitude; },
  "I6": function() { return /* reexport */ notifyPaystubsRequiredQuantity; },
  "u5": function() { return /* reexport */ prefillClientInfo; },
  "X7": function() { return /* reexport */ validateFormStep; },
  "Eo": function() { return /* reexport */ validatePreviousMoveDate; }
});

// UNUSED EXPORTS: EApplicationStepsLabel, fetchAgreementSigningUrl, fetchCreditScore, getDriverLicenseChannel, getDriverLicenseVerificationUrl, subscribeDriverLicenseHook

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./enums/analytics/index.ts
var analytics = __webpack_require__(79251);
// EXTERNAL MODULE: ./enums/constants/pusher.ts
var constants_pusher = __webpack_require__(60234);
// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__(39693);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./constants/common.ts
var common = __webpack_require__(88501);
// EXTERNAL MODULE: ./utils/analytics.ts
var utils_analytics = __webpack_require__(26451);
// EXTERNAL MODULE: ./utils/common.ts
var utils_common = __webpack_require__(6628);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV3/constant.ts
var constant = __webpack_require__(21325);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/constant.ts
var ApplicationFormModalV2_constant = __webpack_require__(29166);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/utils/common.ts














function logStepToAmplitude(step) {
    switch(step){
        case ApplicationFormModalV2_constant/* EApplicationStepBar.DO_YOU_QUALIFY */.X0.DO_YOU_QUALIFY:
            (0,utils_analytics/* logEvent */.Kz)(analytics/* CategoryEnum.APPLICATION_FORM */.Bf.APPLICATION_FORM, analytics/* ActionEnum.PERSONAL_INFO_STEP_LOADED */.Xv.PERSONAL_INFO_STEP_LOADED);
        default:
            break;
    }
}
function validateFormStep(activeStep, formValue, isDoneCompleteScreening, isMobileTablet) {
    var isGeneralApplication = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    switch(activeStep){
        case ApplicationFormModalV2_constant/* EApplicationStepBar.DO_YOU_QUALIFY */.X0.DO_YOU_QUALIFY:
            if ((formValue === null || formValue === void 0 ? void 0 : formValue.confirm) && (formValue === null || formValue === void 0 ? void 0 : formValue.email) && (formValue === null || formValue === void 0 ? void 0 : formValue.firstName) && (formValue === null || formValue === void 0 ? void 0 : formValue.lastName)) {
                //* INFO: Validate Email Address and name, allow phone number as name
                var isValidEmail = common/* EMAIL_PATTERN.test */.QI.test(formValue.email);
                var isValidFirstName = common/* NAME_PATTERN.test */.Ge.test(formValue.firstName) || common/* RAW_PHONE_NUMBER_PATTERN.test */.kc.test(formValue.firstName);
                var isValidLastName = common/* NAME_PATTERN.test */.Ge.test(formValue.lastName) || common/* RAW_PHONE_NUMBER_PATTERN.test */.kc.test(formValue.lastName);
                var isValidPhoneNumber = isGeneralApplication ? common/* RAW_PHONE_NUMBER_PATTERN.test */.kc.test((0,utils_common/* getRawUSPhoneNumber */.vM)(formValue === null || formValue === void 0 ? void 0 : formValue.phoneNumber)) : true;
                return isValidEmail && isValidFirstName && isValidLastName && isValidPhoneNumber;
            }
            return false;
        case ApplicationFormModalV2_constant/* EApplicationStepBar.SHARE_YOUR_DEETS */.X0.SHARE_YOUR_DEETS:
            var ref;
            if ((formValue === null || formValue === void 0 ? void 0 : formValue.monthlyIncome) && !common/* MONTHLY_INCOME_PATTERN.test */.ZI.test(String(formValue === null || formValue === void 0 ? void 0 : formValue.monthlyIncome))) {
                return false;
            }
            if ((formValue === null || formValue === void 0 ? void 0 : formValue.ssn) && !(formValue === null || formValue === void 0 ? void 0 : (ref = formValue.ssn) === null || ref === void 0 ? void 0 : ref.includes("X")) && (formValue === null || formValue === void 0 ? void 0 : formValue.addressLine1) && (formValue === null || formValue === void 0 ? void 0 : formValue.city) && (formValue === null || formValue === void 0 ? void 0 : formValue.state) && (formValue === null || formValue === void 0 ? void 0 : formValue.zipCode) && common/* ZIP_CODE_PATTERN.test */.fY.test(formValue.zipCode)) {
                //* INFO: Validate dateOfBirth on desktop
                if ((formValue === null || formValue === void 0 ? void 0 : formValue.dateOfBirth) && dayjs_min_default()(formValue === null || formValue === void 0 ? void 0 : formValue.dateOfBirth).isValid() && !isMobileTablet) {
                    //* INFO Check if dateOfBirth is valid
                    return common/* DATE_OF_BIRTH_PATTERN.test */.Vo.test(formValue.dateOfBirth);
                }
                var ref1, ref2, ref3;
                //* INFO: Validate dateOfBirth on mobile & tablet
                var dateOfBirth = "".concat((ref1 = formValue === null || formValue === void 0 ? void 0 : formValue.month) !== null && ref1 !== void 0 ? ref1 : 0, "/").concat((ref2 = formValue === null || formValue === void 0 ? void 0 : formValue.day) !== null && ref2 !== void 0 ? ref2 : 0, "/").concat((ref3 = formValue === null || formValue === void 0 ? void 0 : formValue.year) !== null && ref3 !== void 0 ? ref3 : 0);
                if (Boolean(dayjs_min_default()(dateOfBirth).isValid() && (formValue === null || formValue === void 0 ? void 0 : formValue.month) && (formValue === null || formValue === void 0 ? void 0 : formValue.day) && (formValue === null || formValue === void 0 ? void 0 : formValue.year))) {
                    return common/* DATE_OF_BIRTH_PATTERN.test */.Vo.test(dateOfBirth);
                }
                return false;
            }
            return false;
        case ApplicationFormModalV2_constant/* EApplicationStepBar.COMPLETE_SCREENING */.X0.COMPLETE_SCREENING:
            if ((formValue === null || formValue === void 0 ? void 0 : formValue.previousLandlordPhoneNumber) || (formValue === null || formValue === void 0 ? void 0 : formValue.previousLandlordName)) {
                var isValidPhoneNumber1 = (formValue === null || formValue === void 0 ? void 0 : formValue.previousLandlordPhoneNumber) ? common/* RAW_PHONE_NUMBER_PATTERN.test */.kc.test(formValue.previousLandlordPhoneNumber) : true;
                var isValidName = (formValue === null || formValue === void 0 ? void 0 : formValue.previousLandlordName) ? common/* NAME_WITH_NUMBER_PATTERN.test */.Jp.test(formValue.previousLandlordName) : true;
                var isValidEmail1 = (formValue === null || formValue === void 0 ? void 0 : formValue.previousLandlordEmail) ? common/* EMAIL_PATTERN.test */.QI.test(formValue.previousLandlordEmail) : true;
                return isValidPhoneNumber1 && isValidName && isValidEmail1;
            }
            return isDoneCompleteScreening;
        default:
            return true;
    }
}
function prefillClientInfo(houseApplication, reset, getValues) {
    return _prefillClientInfo.apply(this, arguments);
}
function _prefillClientInfo() {
    _prefillClientInfo = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(houseApplication, reset, getValues) {
        var formValue, prefillData, currentDateOfBirth;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    formValue = getValues();
                    prefillData = {
                        phoneNumber: houseApplication.phoneNumber,
                        firstName: houseApplication.firstName,
                        lastName: houseApplication.lastName,
                        email: houseApplication.email,
                        ssn: houseApplication.ssn,
                        zipCode: houseApplication.zipCode,
                        houseNumber: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.houseNumber,
                        streetName: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.streetName,
                        city: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.city,
                        state: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.state,
                        addressLine1: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.addressLine1,
                        addressLine2: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.addressLine2,
                        driverLicenseFrontPhotoUrl: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.driverLicenseFrontPhotoUrl,
                        driverLicenseBackPhotoUrl: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.driverLicenseBackPhotoUrl,
                        monthlyIncome: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.monthlyIncome,
                        previousLandlordName: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.previousLandlordName,
                        previousLandlordPhoneNumber: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.previousLandlordPhoneNumber,
                        previousLandlordEmail: houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.previousLandlordEmail,
                        previousMoveInDate: (houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.previousMoveInDate) ? new Date(houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.previousMoveInDate) : undefined,
                        previousMoveOutDate: (houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.previousMoveOutDate) ? new Date(houseApplication === null || houseApplication === void 0 ? void 0 : houseApplication.previousMoveOutDate) : undefined
                    };
                    //* INFO: Handle dateOfBirth field in case mobile or desktop/tablet
                    if (houseApplication.dateOfBirth && dayjs_min_default()(houseApplication.dateOfBirth).isValid()) {
                        currentDateOfBirth = houseApplication.dateOfBirth;
                        prefillData.dateOfBirth = currentDateOfBirth;
                        // INFO: prefill data dateOfBirth on Mobile screen
                        prefillData.month = dayjs_min_default()(currentDateOfBirth).format("MM");
                        prefillData.day = dayjs_min_default()(currentDateOfBirth).format("DD");
                        prefillData.year = dayjs_min_default()(currentDateOfBirth).format("YYYY");
                    }
                    reset((0,_object_spread/* default */.Z)({}, formValue, prefillData));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _prefillClientInfo.apply(this, arguments);
}
function getReferrers(formValue, filteredFormValue) {
    var referrers = (0,utils_common/* getValidArray */._b)((0,_to_consumable_array/* default */.Z)((0,utils_common/* getValidArray */._b)(filteredFormValue === null || filteredFormValue === void 0 ? void 0 : filteredFormValue.referrers)).concat((0,_to_consumable_array/* default */.Z)((formValue === null || formValue === void 0 ? void 0 : formValue.otherReferrer) ? [
        formValue.otherReferrer
    ] : [])));
    return compact_default()(referrers);
}
function common_getDriverLicenseChannel(phoneNumber) {
    var ref, ref1;
    if (!phoneNumber) {
        return "";
    }
    // INFO: remove "+" char in phone number to make chanel id
    var customerId = "".concat(phoneNumber).replace("+", "");
    var driverLicenseChannel = pusherChannels === null || pusherChannels === void 0 ? void 0 : (ref = pusherChannels.driverLicense) === null || ref === void 0 ? void 0 : (ref1 = ref.verified) === null || ref1 === void 0 ? void 0 : ref1.value(customerId);
    return driverLicenseChannel;
}
function notifyPaystubsRequiredQuantity() {
    react_toastify_esm/* toast.error */.Am.error("Please upload at least ".concat(ApplicationFormModalV2_constant/* PAYSTUBS_REQUIRED_QUANTITY */.Kk, " paystubs"), {
        toastId: "paystub-quantity-error"
    });
}
function getNewCompletedState(lastCompletedStep, lastCompletedState) {
    var completedStateListV3 = Object.values(constant/* EApplicationCompletedStateV3 */.xK);
    if (!lastCompletedState) {
        return completedStateListV3[0];
    }
    ;
    if (!completedStateListV3.includes(lastCompletedState)) {
        return completedStateListV3[1];
    }
    return completedStateListV3[lastCompletedStep + 1];
}
function getContinueApplyingStep(lastCompletedState) {
    var completedStateListV3 = Object.values(constant/* EApplicationCompletedStateV3 */.xK);
    if (!lastCompletedState || !completedStateListV3.includes(lastCompletedState)) {
        return 0;
    }
    return completedStateListV3.indexOf(lastCompletedState) - 1;
}
function checkValidDayOfMonth(month, day, year) {
    var date = new Date(year, month - 1, day) // *INFO: month index is 0-11
    ;
    var isValidDay = date.getDate() === day;
    var isValidMonth = date.getMonth() === month - 1;
    var isValidYear = date.getFullYear() === year;
    // *INFO: check if year or month is NaN (Number(undefined) = NaN))
    if (!month) {
        return isValidDay;
    }
    if (!year) {
        return isValidDay && isValidMonth;
    }
    return isValidDay && isValidMonth && isValidYear;
}
function validatePreviousMoveDate(previousMoveDate) {
    return (0,utils_common/* getValidArray */._b)(previousMoveDate).map(function(date) {
        var formattedDate = dayjs_min_default()(date).add(1, "day");
        return date && formattedDate.isValid() ? formattedDate.toDate() : undefined;
    });
}

// EXTERNAL MODULE: ./API/houseApplication/crs.ts
var crs = __webpack_require__(54166);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/utils/crs.ts





function fetchCreditScore(formValue) {
    return _fetchCreditScore.apply(this, arguments);
}
function _fetchCreditScore() {
    _fetchCreditScore = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formValue) {
        var ref, isTestingCRS, tenantData, ref1, ref2, ref3, creditScoreResponse;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    isTestingCRS = formValue === null || formValue === void 0 ? void 0 : (ref = formValue.email) === null || ref === void 0 ? void 0 : ref.includes(ApplicationFormModalV2_constant/* TEST_CRS_EMAIL_SUB */.fh);
                    tenantData = {};
                    if (isTestingCRS) {
                        tenantData = ApplicationFormModalV2_constant/* TEST_CRS_CREDIT_SCORE_MOCK_DATA */.Uq;
                    } else {
                        ;
                        ;
                        tenantData = {
                            firstName: (ref2 = formValue === null || formValue === void 0 ? void 0 : formValue.firstName) !== null && ref2 !== void 0 ? ref2 : "",
                            lastName: (ref3 = formValue === null || formValue === void 0 ? void 0 : formValue.lastName) !== null && ref3 !== void 0 ? ref3 : "",
                            dob: dayjs_min_default()(formValue === null || formValue === void 0 ? void 0 : formValue.dateOfBirth).format("YYYY-MM-DD"),
                            ssn: formValue === null || formValue === void 0 ? void 0 : (ref1 = formValue.ssn) === null || ref1 === void 0 ? void 0 : ref1.replaceAll("-", ""),
                            phone: formValue === null || formValue === void 0 ? void 0 : formValue.phoneNumber
                        };
                    }
                    _ctx.next = 6;
                    return (0,crs/* getFICOCreditScore */.Wt)(tenantData);
                case 6:
                    creditScoreResponse = _ctx.sent;
                    return _ctx.abrupt("return", creditScoreResponse);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchCreditScore.apply(this, arguments);
}
function getCreditScore(formValue) {
    return _getCreditScore.apply(this, arguments);
}
function _getCreditScore() {
    _getCreditScore = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formValue) {
        var creditScoreResponse, score, pdfReportId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchCreditScore(formValue);
                case 2:
                    creditScoreResponse = _ctx.sent;
                    score = creditScoreResponse.score, pdfReportId = creditScoreResponse.pdfReportId;
                    if (pdfReportId && (formValue === null || formValue === void 0 ? void 0 : formValue.phoneNumber) && (formValue === null || formValue === void 0 ? void 0 : formValue.buildiumUnitId)) {
                        (0,crs/* uploadCRSReport */.we)(pdfReportId, formValue.phoneNumber, formValue.buildiumUnitId);
                    }
                    return _ctx.abrupt("return", score);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCreditScore.apply(this, arguments);
}
function handleUploadCriminalReport(formValue) {
    return _handleUploadCriminalReport.apply(this, arguments);
}
function _handleUploadCriminalReport() {
    _handleUploadCriminalReport = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formValue) {
        var ref, isTestingCRS, tenantData, ref1, ref2, ref3, ref4, ref5;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    isTestingCRS = formValue === null || formValue === void 0 ? void 0 : (ref = formValue.email) === null || ref === void 0 ? void 0 : ref.includes(ApplicationFormModalV2_constant/* TEST_CRS_EMAIL_SUB */.fh);
                    tenantData = {};
                    if (isTestingCRS) {
                        tenantData = ApplicationFormModalV2_constant/* TEST_CRS_CRIMINAL_MOCK_DATA */.C9;
                    } else {
                        ;
                        ;
                        tenantData = {
                            first: (ref2 = formValue === null || formValue === void 0 ? void 0 : formValue.firstName) !== null && ref2 !== void 0 ? ref2 : "",
                            last: (ref3 = formValue === null || formValue === void 0 ? void 0 : formValue.lastName) !== null && ref3 !== void 0 ? ref3 : "",
                            city: (ref4 = formValue === null || formValue === void 0 ? void 0 : formValue.city) !== null && ref4 !== void 0 ? ref4 : "",
                            state: (ref5 = formValue === null || formValue === void 0 ? void 0 : formValue.state) !== null && ref5 !== void 0 ? ref5 : "",
                            dob: dayjs_min_default()(formValue === null || formValue === void 0 ? void 0 : formValue.dateOfBirth).format("MM-DD-YYYY"),
                            ssn: formValue === null || formValue === void 0 ? void 0 : (ref1 = formValue.ssn) === null || ref1 === void 0 ? void 0 : ref1.replaceAll("-", ""),
                            zip: formValue === null || formValue === void 0 ? void 0 : formValue.zipCode
                        };
                    }
                    if (!((formValue === null || formValue === void 0 ? void 0 : formValue.phoneNumber) && (formValue === null || formValue === void 0 ? void 0 : formValue.buildiumUnitId))) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 7;
                    return (0,crs/* uploadCriminalReport */.Co)(formValue === null || formValue === void 0 ? void 0 : formValue.phoneNumber, formValue === null || formValue === void 0 ? void 0 : formValue.buildiumUnitId, tenantData);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _handleUploadCriminalReport.apply(this, arguments);
}
function handleUploadEvectionReport(formValue) {
    return _handleUploadEvectionReport.apply(this, arguments);
}
function _handleUploadEvectionReport() {
    _handleUploadEvectionReport = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formValue) {
        var ref, isTestingCRS, tenantData, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    isTestingCRS = formValue === null || formValue === void 0 ? void 0 : (ref = formValue.email) === null || ref === void 0 ? void 0 : ref.includes(ApplicationFormModalV2_constant/* TEST_CRS_EMAIL_SUB */.fh);
                    tenantData = {};
                    if (isTestingCRS) {
                        tenantData = ApplicationFormModalV2_constant/* TEST_CRS_EVICTION_MOCK_DATA */._G;
                    } else {
                        ;
                        ;
                        tenantData = {
                            first: (ref2 = formValue === null || formValue === void 0 ? void 0 : formValue.firstName) !== null && ref2 !== void 0 ? ref2 : "",
                            last: (ref3 = formValue === null || formValue === void 0 ? void 0 : formValue.lastName) !== null && ref3 !== void 0 ? ref3 : "",
                            city: (ref4 = formValue === null || formValue === void 0 ? void 0 : formValue.city) !== null && ref4 !== void 0 ? ref4 : "",
                            state: (ref5 = formValue === null || formValue === void 0 ? void 0 : formValue.state) !== null && ref5 !== void 0 ? ref5 : "",
                            dob: dayjs_min_default()(formValue === null || formValue === void 0 ? void 0 : formValue.dateOfBirth).format("MM-DD-YYYY"),
                            ssn: formValue === null || formValue === void 0 ? void 0 : (ref1 = formValue.ssn) === null || ref1 === void 0 ? void 0 : ref1.replaceAll("-", ""),
                            zip: formValue === null || formValue === void 0 ? void 0 : formValue.zipCode,
                            streetName: (ref6 = formValue === null || formValue === void 0 ? void 0 : formValue.streetName) !== null && ref6 !== void 0 ? ref6 : "",
                            houseNumber: (ref7 = formValue === null || formValue === void 0 ? void 0 : formValue.houseNumber) !== null && ref7 !== void 0 ? ref7 : ""
                        };
                    }
                    if (!((formValue === null || formValue === void 0 ? void 0 : formValue.phoneNumber) && (formValue === null || formValue === void 0 ? void 0 : formValue.buildiumUnitId) && (tenantData === null || tenantData === void 0 ? void 0 : tenantData.city) && (tenantData === null || tenantData === void 0 ? void 0 : tenantData.state))) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 7;
                    return (0,crs/* uploadEvictionReport */.QP)(formValue === null || formValue === void 0 ? void 0 : formValue.phoneNumber, formValue === null || formValue === void 0 ? void 0 : formValue.buildiumUnitId, tenantData);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _handleUploadEvectionReport.apply(this, arguments);
}

// EXTERNAL MODULE: ./enums/common/index.ts
var enums_common = __webpack_require__(71074);
// EXTERNAL MODULE: ./enums/pusher/index.ts
var enums_pusher = __webpack_require__(85159);
// EXTERNAL MODULE: ./API/applicant/index.ts
var applicant = __webpack_require__(28330);
// EXTERNAL MODULE: ./API/error.ts
var error = __webpack_require__(76214);
// EXTERNAL MODULE: ./API/houseApplication/index.ts
var houseApplication = __webpack_require__(55262);
// EXTERNAL MODULE: ./API/listing/index.ts
var listing = __webpack_require__(22999);
// EXTERNAL MODULE: ./API/stripe/index.ts
var stripe = __webpack_require__(81657);
// EXTERNAL MODULE: ./utils/pusher.ts
var utils_pusher = __webpack_require__(92594);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/utils/index.ts + 12 modules
var utils = __webpack_require__(53722);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/utils/fetchData.ts
















function fetchClientSecret(setClientSecret, setClientInfo, amount, formValue, currentClientInfo) {
    return _fetchClientSecret.apply(this, arguments);
}
function _fetchClientSecret() {
    _fetchClientSecret = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(setClientSecret, setClientInfo, amount, formValue, currentClientInfo) {
        var clientInfo, secret;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    clientInfo = {
                        name: (0,utils_common/* getFullName */.Pp)(formValue === null || formValue === void 0 ? void 0 : formValue.firstName, formValue === null || formValue === void 0 ? void 0 : formValue.lastName),
                        email: formValue === null || formValue === void 0 ? void 0 : formValue.email,
                        phone: (0,utils_common/* getRawUSPhoneNumber */.vM)(formValue === null || formValue === void 0 ? void 0 : formValue.phoneNumber),
                        amount: (0,utils_common/* convertUSDToCent */.X3)(amount)
                    };
                    if (!(currentClientInfo && (currentClientInfo === null || currentClientInfo === void 0 ? void 0 : currentClientInfo.email) === clientInfo.email && (currentClientInfo === null || currentClientInfo === void 0 ? void 0 : currentClientInfo.name) === clientInfo.name)) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 4:
                    _ctx.next = 6;
                    return (0,stripe/* getStripeClientSecret */.sc)(clientInfo);
                case 6:
                    secret = _ctx.sent;
                    if (secret) {
                        setClientSecret(secret || null);
                        setClientInfo(clientInfo);
                    }
                    _ctx.next = 13;
                    break;
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    (0,error/* handleError */.S)(_ctx.t0, "components/pages/DetailPage/components/ApplicationFormModalV2", "fetchClientSecret");
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return _fetchClientSecret.apply(this, arguments);
}
function fetchAgreementSigningUrl(formValue, shortAddress, buildiumPropertyId, unit, callback) {
    return _fetchAgreementSigningUrl.apply(this, arguments);
}
function _fetchAgreementSigningUrl() {
    _fetchAgreementSigningUrl = _async_to_generator(regeneratorRuntime.mark(function _callee(formValue, shortAddress, buildiumPropertyId, unit, callback) {
        var ref, membershipStartDate, ref1, ref2, ref3, ref4, ref5, ref6, agreementData, envelopeData;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    membershipStartDate = (ref = formValue === null || formValue === void 0 ? void 0 : formValue.moveInDate) !== null && ref !== void 0 ? ref : new Date();
                    ;
                    agreementData = {
                        homeAddress: "".concat((ref1 = formValue === null || formValue === void 0 ? void 0 : formValue.address) !== null && ref1 !== void 0 ? ref1 : "", " ").concat(unit === null || unit === void 0 ? void 0 : unit.name, " ").concat(buildiumPropertyId !== null && buildiumPropertyId !== void 0 ? buildiumPropertyId : ""),
                        membershipStartDate: membershipStartDate,
                        membershipEndDate: dayjs(membershipStartDate).add(1, "year").toDate(),
                        securityDeposit: SECURITY_DEPOSIT,
                        phoneNumber: (ref2 = formValue === null || formValue === void 0 ? void 0 : formValue.phoneNumber) !== null && ref2 !== void 0 ? ref2 : "",
                        shortAddress: "".concat(shortAddress !== null && shortAddress !== void 0 ? shortAddress : "", " ").concat(unit === null || unit === void 0 ? void 0 : unit.name),
                        fullName: "".concat((ref3 = formValue === null || formValue === void 0 ? void 0 : formValue.firstName) !== null && ref3 !== void 0 ? ref3 : "", " ").concat((ref4 = formValue === null || formValue === void 0 ? void 0 : formValue.lastName) !== null && ref4 !== void 0 ? ref4 : ""),
                        email: (ref5 = formValue === null || formValue === void 0 ? void 0 : formValue.email) !== null && ref5 !== void 0 ? ref5 : "",
                        price: (ref6 = unit === null || unit === void 0 ? void 0 : unit.price) !== null && ref6 !== void 0 ? ref6 : 0,
                        returnUrl: DOCUSIGN_LOADING_PAGE_URL
                    };
                    _ctx.next = 7;
                    return getSigningLeaseAgreement(agreementData);
                case 7:
                    envelopeData = _ctx.sent;
                    if (typeof callback === "function") {
                        callback(envelopeData);
                    }
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    handleError(_ctx.t0, "components/pages/DetailPage/components/ApplicationFormModalV2", "fetchAgreementSigningUrl");
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return _fetchAgreementSigningUrl.apply(this, arguments);
}
function getDriverLicenseVerificationUrl(phoneNumber, setUrl, isEnableLoginFeature, userId) {
    return _getDriverLicenseVerificationUrl.apply(this, arguments);
}
function _getDriverLicenseVerificationUrl() {
    _getDriverLicenseVerificationUrl = _async_to_generator(regeneratorRuntime.mark(function _callee(phoneNumber, setUrl, isEnableLoginFeature, userId) {
        var customerUid, response, responseWithUserId;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    customerUid = String(phoneNumber);
                    _ctx.next = 4;
                    return createDriverLicenseVerification(customerUid);
                case 4:
                    response = _ctx.sent;
                    if (!isEnableLoginFeature) {
                        _ctx.next = 12;
                        break;
                    }
                    _ctx.next = 8;
                    return createDriverLicenseVerificationWithUserId(String(userId));
                case 8:
                    responseWithUserId = _ctx.sent;
                    if ((response === null || response === void 0 ? void 0 : response.hostedUrl) && (responseWithUserId === null || responseWithUserId === void 0 ? void 0 : responseWithUserId.hostedUrl)) {
                        localStorage.setItem(LocalStorageKeyEnum.REFRESH_TOKEN, response === null || response === void 0 ? void 0 : response.refreshToken);
                        setUrl(response === null || response === void 0 ? void 0 : response.hostedUrl);
                    } else {
                        localStorage.setItem(LocalStorageKeyEnum.REFRESH_TOKEN, "");
                    }
                    _ctx.next = 13;
                    break;
                case 12:
                    {
                        if (response === null || response === void 0 ? void 0 : response.hostedUrl) {
                            localStorage.setItem(LocalStorageKeyEnum.REFRESH_TOKEN, response === null || response === void 0 ? void 0 : response.refreshToken);
                            setUrl(response === null || response === void 0 ? void 0 : response.hostedUrl);
                        } else {
                            localStorage.setItem(LocalStorageKeyEnum.REFRESH_TOKEN, "");
                        }
                    }
                case 13:
                    _ctx.next = 18;
                    break;
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](0);
                    handleError(_ctx.t0, "components/pages/DetailPage/components/ApplicationFormModalV2/utils.tsx", "getDriverLicenseVerificationUrl");
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                15
            ]
        ]);
    }));
    return _getDriverLicenseVerificationUrl.apply(this, arguments);
}
function subscribeDriverLicenseHook(buildiumUnitId, phoneNumber, isDriverLicenseVerified, setUrl, setStep, setIsLoading, setIsDriverLicenseVerified, buildiumPropertyId) {
    return _subscribeDriverLicenseHook.apply(this, arguments);
}
function _subscribeDriverLicenseHook() {
    _subscribeDriverLicenseHook = _async_to_generator(regeneratorRuntime.mark(function _callee(buildiumUnitId, phoneNumber, isDriverLicenseVerified, setUrl, setStep, setIsLoading, setIsDriverLicenseVerified, buildiumPropertyId) {
        var driverLicenseChannel, verifyDriverLicenseChannel;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    isDriverLicenseVerified === false && setIsLoading(true);
                    driverLicenseChannel = getDriverLicenseChannel(phoneNumber);
                    verifyDriverLicenseChannel = pusher.subscribe(driverLicenseChannel);
                    verifyDriverLicenseChannel.bind(PusherEventName.REFETCH, function() {
                        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(payload) {
                            var ref, refreshToken;
                            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.prev = 0;
                                        if ((payload === null || payload === void 0 ? void 0 : payload.action) === EDriverLicenseTypeEnum.ACCEPT || (payload === null || payload === void 0 ? void 0 : payload.action) === EDriverLicenseTypeEnum.REVIEW) {
                                            ;
                                            refreshToken = (ref = localStorage.getItem(LocalStorageKeyEnum.REFRESH_TOKEN)) !== null && ref !== void 0 ? ref : "";
                                            getDriverLicenseVerification(refreshToken, buildiumPropertyId !== null && buildiumPropertyId !== void 0 ? buildiumPropertyId : 0, buildiumUnitId);
                                            setIsLoading(false);
                                            setIsDriverLicenseVerified(true);
                                            setStep(ECompleteScreeningSteps.PAYSTUB_UPLOADER);
                                        }
                                        if (!((payload === null || payload === void 0 ? void 0 : payload.action) === EDriverLicenseTypeEnum.REJECT)) {
                                            _ctx.next = 6;
                                            break;
                                        }
                                        _ctx.next = 5;
                                        return getDriverLicenseVerificationUrl(phoneNumber, setUrl);
                                    case 5:
                                        toast.warning("Your driver license was rejected, please reverify your driver license!");
                                    case 6:
                                        _ctx.next = 11;
                                        break;
                                    case 8:
                                        _ctx.prev = 8;
                                        _ctx.t0 = _ctx["catch"](0);
                                        handleError(_ctx.t0, "components/pages/DetailPage/components/ApplicationFormModalV2/utils.tsx", "subscribeDriverLicenseHook");
                                    case 11:
                                        _ctx.prev = 11;
                                        pusher.unsubscribe(driverLicenseChannel);
                                        return _ctx.finish(11);
                                    case 14:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    8,
                                    11,
                                    14
                                ]
                            ]);
                        }));
                        return function(payload) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _subscribeDriverLicenseHook.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(59876);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/chakra-ui-steps/dist/chakra-ui-steps.es.js
var chakra_ui_steps_es = __webpack_require__(47822);
// EXTERNAL MODULE: ./enums/theme/index.ts
var theme = __webpack_require__(60431);
// EXTERNAL MODULE: ./hooks/useBreakPoint.ts
var useBreakPoint = __webpack_require__(41894);
// EXTERNAL MODULE: ./hooks/useStores.ts
var useStores = __webpack_require__(19263);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js
var mobxreact_esm = __webpack_require__(29323);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/applicationForm.context.ts
var applicationForm_context = __webpack_require__(65798);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/applicationFormModalV2.styles.ts
var applicationFormModalV2_styles = __webpack_require__(82120);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/completeScreening.context.ts
var completeScreening_context = __webpack_require__(83049);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/CompleteScreening/index.tsx




















var CompleteScreening = function() {
    var handleNextStep = function handleNextStep() {
        if (activeStep === utils/* ECompleteScreeningSteps.DRIVER_LICENSE */.U1.DRIVER_LICENSE) {
            if (isDriverLicenses) {
                typeof setIsDriverLicenseVerified === "function" && setIsDriverLicenseVerified(true);
                typeof setCompleteScreeningStep === "function" && setCompleteScreeningStep(utils/* ECompleteScreeningSteps.PAYSTUB_UPLOADER */.U1.PAYSTUB_UPLOADER);
            }
        }
        nextStep();
    };
    var ref = (0,react.useContext)(applicationForm_context/* ApplicationContext */.Z), isLoading = ref.isLoading, isBackLoading = ref.isBackLoading, setIsBackLoading = ref.setIsBackLoading, setIsLoading = ref.setIsLoading, setSideBarStep = ref.setStep, setCompleteScreeningStep = ref.setCompleteScreeningStep, completeScreeningStep = ref.completeScreeningStep, setIsDriverLicenseVerified = ref.setIsDriverLicenseVerified;
    var ref1 = (0,chakra_ui_steps_es/* useSteps */.h4)({
        initialStep: 0
    }), nextStep = ref1.nextStep, activeStep = ref1.activeStep, previousStep = ref1.prevStep, setStep = ref1.setStep;
    var ref2 = (0,useStores/* useStores */.m)(), houseApplicationStore = ref2.houseApplicationStore, userBackgroundInformationStore = ref2.userBackgroundInformationStore;
    var isPaymentExpired = houseApplicationStore.isPaymentExpired;
    var userBackgroundInformation = userBackgroundInformationStore.userBackgroundInformation;
    var isDesktop = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.LG */.yE.LG);
    var ref3 = (0,react.useState)(false), isDriverLicenses = ref3[0], setIsDriverLicenses = ref3[1];
    var getValues = (0,index_esm/* useFormContext */.Gc)().getValues;
    var formValue = getValues();
    var paystubFiles = (0,utils_common/* getValidArray */._b)(userBackgroundInformation === null || userBackgroundInformation === void 0 ? void 0 : userBackgroundInformation.paystubFiles);
    var steps = (0,react.useMemo)(function() {
        return (0,utils/* getCompleteScreeningSteps */.Vk)((0,utils_common/* getValidArray */._b)(paystubFiles).length > 0 ? paystubFiles : []);
    }, [
        handleNextStep,
        handlePreviousStep
    ]);
    var isUsingStepButton = [
        utils/* ECompleteScreeningSteps.PAYMENT_INFORMATION */.U1.PAYMENT_INFORMATION,
        utils/* ECompleteScreeningSteps.PAYSTUB_UPLOADER */.U1.PAYSTUB_UPLOADER
    ].includes(activeStep);
    function handlePreviousStep() {
        return _handlePreviousStep.apply(this, arguments);
    }
    function _handlePreviousStep() {
        _handlePreviousStep = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        typeof setIsBackLoading === "function" && setIsBackLoading(true);
                        _ctx.prev = 1;
                        if (!(activeStep === utils/* ECompleteScreeningSteps.PAYMENT_INFORMATION */.U1.PAYMENT_INFORMATION && isPaymentExpired)) {
                            _ctx.next = 5;
                            break;
                        }
                        setSideBarStep(ApplicationFormModalV2_constant/* EApplicationStepBar.SHARE_YOUR_DEETS */.X0.SHARE_YOUR_DEETS);
                        return _ctx.abrupt("return");
                    case 5:
                        if (!(activeStep === utils/* ECompleteScreeningSteps.DRIVER_LICENSE */.U1.DRIVER_LICENSE && !isPaymentExpired)) {
                            _ctx.next = 8;
                            break;
                        }
                        setSideBarStep(ApplicationFormModalV2_constant/* EApplicationStepBar.SHARE_YOUR_DEETS */.X0.SHARE_YOUR_DEETS);
                        return _ctx.abrupt("return");
                    case 8:
                        previousStep();
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,error/* handleError */.S)(_ctx.t0, "components/pages/DetailPage/components/ApplicationFormModalV2", "handlePreviousStep");
                    case 14:
                        _ctx.prev = 14;
                        typeof setIsLoading === "function" && setIsLoading(false);
                        typeof setIsBackLoading === "function" && setIsBackLoading(false);
                        return _ctx.finish(14);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    14,
                    18
                ]
            ]);
        }));
        return _handlePreviousStep.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        if (completeScreeningStep) {
            setStep(completeScreeningStep);
        }
    }, [
        completeScreeningStep
    ]);
    (0,react.useEffect)(function() {
        if (activeStep === utils/* ECompleteScreeningSteps.DRIVER_LICENSE */.U1.DRIVER_LICENSE) {
            if ((formValue === null || formValue === void 0 ? void 0 : formValue.driverLicenseFrontPhotoUrl) && (formValue === null || formValue === void 0 ? void 0 : formValue.driverLicenseBackPhotoUrl)) {
                typeof setIsDriverLicenses === "function" && setIsDriverLicenses(true);
            }
            typeof setCompleteScreeningStep === "function" && setCompleteScreeningStep(utils/* ECompleteScreeningSteps.DRIVER_LICENSE */.U1.DRIVER_LICENSE);
        }
    }, [
        activeStep
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(completeScreening_context/* CompleteScreeningContext.Provider */.T.Provider, {
        value: {
            nextStep: nextStep,
            handleNextStep: handleNextStep,
            handlePreviousStep: handlePreviousStep,
            isDriverLicenses: isDriverLicenses,
            setIsDriverLicenses: setIsDriverLicenses
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_steps_es/* Steps */.Rg, {
            hidden: true,
            activeStep: activeStep,
            labelOrientation: "vertical",
            responsive: false,
            children: steps.map(function(param) {
                var label = param.label, content = param.content;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_steps_es/* Step */.h8, {
                    label: label,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                        spacing: 0,
                        textAlign: "justify",
                        background: "white",
                        height: {
                            base: "full",
                            lg: completeScreeningStep === utils/* ECompleteScreeningSteps.DRIVER_LICENSE */.U1.DRIVER_LICENSE ? "100vh" : "auto"
                        },
                        justifyContent: {
                            base: "space-between",
                            lg: "flex-start"
                        },
                        width: "full",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                                spacing: 0,
                                textAlign: "justify",
                                background: "white",
                                overflowY: {
                                    base: "auto",
                                    md: "hidden"
                                },
                                flexGrow: 0.9,
                                height: {
                                    base: "full",
                                    lg: "auto"
                                },
                                width: "full",
                                marginBottom: {
                                    base: 6,
                                    md: 12,
                                    lg: "auto"
                                },
                                children: content
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                width: "full",
                                maxWidth: {
                                    base: "full",
                                    lg: ApplicationFormModalV2_constant/* DESKTOP_CONTAINER_WIDTH */.n2
                                },
                                alignItems: "space-between",
                                justifyContent: "space-between",
                                spacing: 2,
                                paddingX: completeScreeningStep === utils/* ECompleteScreeningSteps.DRIVER_LICENSE */.U1.DRIVER_LICENSE && isDesktop ? 0 : 4,
                                position: {
                                    base: "absolute",
                                    md: "relative"
                                },
                                bottom: {
                                    base: 6,
                                    md: 12,
                                    lg: "auto"
                                },
                                hidden: isUsingStepButton,
                                paddingBottom: {
                                    lg: 20
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV2_styles/* BottomBackButton */.bQ, {
                                        isLoading: isBackLoading,
                                        onClick: handlePreviousStep,
                                        variant: "solid",
                                        children: "Back"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV2_styles/* BottomButton */.x_, {
                                        colorScheme: "teal",
                                        variant: "solid",
                                        iconSpacing: 2,
                                        onClick: handleNextStep,
                                        isDisabled: completeScreeningStep === utils/* ECompleteScreeningSteps.DRIVER_LICENSE */.U1.DRIVER_LICENSE && !isDriverLicenses ? true : false,
                                        isLoading: isLoading,
                                        rightIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ArrowForwardIcon */.mr, {}),
                                        children: "Continue"
                                    })
                                ]
                            })
                        ]
                    })
                }, label);
            })
        })
    });
};
/* harmony default export */ var components_CompleteScreening = ((0,mobxreact_esm/* observer */.Pi)(CompleteScreening));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/chakra-ui-checkbox.esm.js + 2 modules
var chakra_ui_checkbox_esm = __webpack_require__(34530);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/FormInput/index.tsx
var FormInput = __webpack_require__(10150);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/SideBar/components/FormPhoneInput/index.tsx
var FormPhoneInput = __webpack_require__(72312);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/DoYouQualify/doYouQualify.module.scss
var doYouQualify_module = __webpack_require__(81647);
var doYouQualify_module_default = /*#__PURE__*/__webpack_require__.n(doYouQualify_module);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/DoYouQualify/index.tsx

















var DoYouQualify = function(props) {
    var ref, ref1;
    var hasPhoneNumberField = props.hasPhoneNumberField;
    var cmsPolicyStore = (0,useStores/* useStores */.m)().cmsPolicyStore;
    var sharedHousePolicies = cmsPolicyStore.sharedHousePolicies, entireHousePolicies = cmsPolicyStore.entireHousePolicies;
    var ref2 = (0,index_esm/* useFormContext */.Gc)(), control = ref2.control, errors = ref2.formState.errors;
    var isNotDesktop = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.LG */.yE.LG);
    var isEntireHouse = (0,react.useContext)(applicationForm_context/* ApplicationContext */.Z).isEntireHouse;
    var requirementList = isEntireHouse ? entireHousePolicies : sharedHousePolicies;
    var ref3;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        spacing: {
            base: 6,
            lg: 8
        },
        paddingX: 4,
        marginTop: {
            base: 0,
            lg: 32
        },
        paddingTop: {
            base: 6,
            lg: 8
        },
        paddingBottom: {
            base: 6,
            lg: 4
        },
        maxWidth: {
            base: "full",
            lg: ApplicationFormModalV2_constant/* DESKTOP_CONTAINER_WIDTH */.n2
        },
        marginX: "auto",
        marginBottom: {
            base: 16,
            md: 28,
            lg: 0
        },
        width: "full",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                spacing: {
                    base: 6,
                    lg: 8
                },
                width: "full",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                        height: isNotDesktop ? "48px" : "40px",
                        width: isNotDesktop ? "calc((100% - 24px) / 2)" : "full",
                        className: (doYouQualify_module_default()).inputContainer,
                        name: "firstName",
                        label: "Your Name",
                        placeholder: "First name",
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                        height: isNotDesktop ? "48px" : "40px",
                        width: isNotDesktop ? "calc((100% - 24px) / 2)" : "full",
                        className: (doYouQualify_module_default()).inputContainer,
                        name: "lastName",
                        label: "Last name",
                        placeholder: "Last name",
                        hideLabel: true,
                        autoComplete: "off"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                height: isNotDesktop ? "48px" : "40px",
                name: "email",
                label: "Your Email Address ",
                placeholder: "Enter Your Email",
                type: "email",
                autoComplete: "off",
                className: classnames_default()((0,_define_property/* default */.Z)({}, (doYouQualify_module_default()).formEmail, (ref3 = errors === null || errors === void 0 ? void 0 : (ref = errors.firstName) === null || ref === void 0 ? void 0 : ref.message) !== null && ref3 !== void 0 ? ref3 : errors === null || errors === void 0 ? void 0 : (ref1 = errors.lastName) === null || ref1 === void 0 ? void 0 : ref1.message))
            }),
            hasPhoneNumberField && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                name: "phoneNumber",
                label: "Your Phone Number",
                hideErrorMessage: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormPhoneInput/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormInput/* default */.Z, {
                name: "confirm",
                label: "Let\u2019s make sure you qualify:",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                        columns: {
                            base: 1,
                            lg: 2
                        },
                        gap: 2,
                        marginTop: 4,
                        children: (0,utils_common/* getValidArray */._b)(requirementList).map(function(requirement, index) {
                            if (!requirement) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                spacing: 2.5,
                                alignItems: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* CheckCircleIcon */.rE, {
                                        color: "teal",
                                        marginTop: "3px"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                        fontSize: "sm",
                                        color: "gray.700",
                                        fontWeight: 400,
                                        lineHeight: 5,
                                        textAlign: "left",
                                        children: requirement
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
                        name: "confirm",
                        control: control,
                        rules: {
                            required: "You must meet the requirements to continue."
                        },
                        render: function(param) {
                            var _field = param.field, onChange = _field.onChange, value = _field.value, ref = _field.ref;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_checkbox_esm/* Checkbox */.XZ, {
                                id: "confirm",
                                textAlign: "left",
                                colorScheme: "teal",
                                color: "gray.700",
                                marginTop: 4,
                                onChange: onChange,
                                ref: ref,
                                isChecked: value,
                                alignItems: "flex-start",
                                className: (doYouQualify_module_default()).checkbox,
                                children: "I understand and meet the above requirements"
                            });
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DoYouQualify = ((0,mobxreact_esm/* observer */.Pi)(DoYouQualify));

// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chakra-ui-menu.esm.js + 3 modules
var chakra_ui_menu_esm = __webpack_require__(42349);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 1 modules
var chakra_ui_button_esm = __webpack_require__(85054);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/SelectSource/index.tsx

















var SelectSource = function() {
    var toggleChecked = function toggleChecked(item) {
        var validCheckedItems = (0,utils_common/* getValidArray */._b)(checkedItems);
        if (typeof setCheckedItems === "function") {
            if (validCheckedItems.findIndex(function(checkedItem) {
                return checkedItem === item;
            }) > -1) {
                var filteredItems = validCheckedItems.filter(function(currentItem) {
                    return currentItem !== item;
                });
                setCheckedItems(filteredItems);
                setValue("referrers", filteredItems);
            } else {
                var newCheckedItems = (0,_to_consumable_array/* default */.Z)(validCheckedItems).concat([
                    item
                ]);
                setCheckedItems(newCheckedItems);
                setValue("referrers", newCheckedItems);
            }
        }
    };
    var ref = (0,react.useContext)(applicationForm_context/* ApplicationContext */.Z), checkedItems = ref.checkedItems, setCheckedItems = ref.setCheckedItems, handleNextStep = ref.handleNextStep, handlePreviousStep = ref.handlePreviousStep;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var checkItemLength = (0,utils_common/* getValidArray */._b)(checkedItems).length;
    var buttonText = "".concat((0,utils_common/* getValidArray */._b)(checkedItems)[0]).concat(checkItemLength > 1 ? ", +".concat(checkItemLength - 1) : "");
    var setValue = (0,index_esm/* useFormContext */.Gc)().setValue;
    var isDesktop = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.LG */.yE.LG);
    function handleSubmitForm() {
        return _handleSubmitForm.apply(this, arguments);
    }
    function _handleSubmitForm() {
        _handleSubmitForm = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var errorMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.t0 = typeof handleNextStep === "function";
                        if (!_ctx.t0) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 5;
                        return handleNextStep();
                    case 5:
                        _ctx.next = 11;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t1 = _ctx["catch"](0);
                        errorMessage = get_default()(_ctx.t1, "error.message");
                        react_toastify_esm/* toast.error */.Am.error(errorMessage);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return _handleSubmitForm.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        maxWidth: {
            base: "full",
            lg: ApplicationFormModalV2_constant/* DESKTOP_CONTAINER_WIDTH */.n2
        },
        marginX: "auto",
        marginTop: {
            base: 6,
            lg: 40
        },
        spacing: 8,
        alignItems: "flex-start",
        width: "full",
        paddingX: {
            base: 4,
            lg: 1
        },
        paddingBottom: {
            base: 0,
            lg: 1
        },
        minHeight: {
            lg: isOpen ? "600px" : "unset"
        },
        overflow: "hidden",
        height: "full",
        marginBottom: {
            base: 24,
            lg: 0
        },
        children: [
            isDesktop && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Text */.xv, {
                fontSize: "md",
                fontWeight: "500",
                color: "gray.700",
                children: [
                    "Congratulations! ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                    " You have been conditionally approved for this unit."
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                width: "full",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                    name: "referrers",
                    label: "How did you hear about us?",
                    autoComplete: "off",
                    children: isDesktop ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_menu_esm/* Menu */.v2, {
                        closeOnSelect: false,
                        computePositionOnMount: true,
                        matchWidth: true,
                        onOpen: function() {
                            setIsOpen(true);
                        },
                        onClose: function() {
                            setIsOpen(false);
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* MenuButton */.j2, {
                                as: chakra_ui_button_esm/* Button */.zx,
                                width: "full",
                                border: "1px solid #E2E8F0",
                                background: "white",
                                iconSpacing: 5,
                                rightIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ChevronDownIcon */.v4, {}),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                    fontSize: "md",
                                    color: "gray.700",
                                    whiteSpace: "nowrap",
                                    fontWeight: "normal",
                                    textAlign: "start",
                                    children: checkItemLength > 0 ? buttonText : "Select Source"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* MenuList */.qy, {
                                zIndex: 1500,
                                children: ApplicationFormModalV2_constant/* refererSource.map */.fU.map(function(option) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_menu_esm/* MenuItem */.sN, {
                                        onClick: function() {
                                            return toggleChecked(option);
                                        },
                                        cursor: "pointer",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_checkbox_esm/* Checkbox */.XZ, {
                                                id: option,
                                                isChecked: (0,utils_common/* getValidArray */._b)(checkedItems).findIndex(function(item) {
                                                    return item === option;
                                                }) > -1,
                                                marginInlineEnd: 3,
                                                colorScheme: "teal",
                                                onMouseDown: function() {
                                                    return toggleChecked(option);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                                children: option
                                            })
                                        ]
                                    }, option);
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
                        marginLeft: 4,
                        width: "full",
                        border: "none",
                        spacing: 4,
                        alignItems: "flex-start",
                        paddingTop: 2,
                        children: ApplicationFormModalV2_constant/* refererSource.map */.fU.map(function(option) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                                width: "stretch",
                                onClick: function() {
                                    return toggleChecked(option);
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_checkbox_esm/* Checkbox */.XZ, {
                                        id: option,
                                        isChecked: (0,utils_common/* getValidArray */._b)(checkedItems).findIndex(function(item) {
                                            return item === option;
                                        }) > -1,
                                        marginInlineEnd: 3,
                                        colorScheme: "teal",
                                        onMouseDown: function() {
                                            return toggleChecked(option);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                        children: option
                                    })
                                ]
                            }, "mobile-".concat(option));
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                height: isDesktop ? "40px" : "48px",
                width: "full",
                name: "otherReferrer",
                label: "Referral's Name (optional)",
                placeholder: "Enter Referral's name",
                isRequired: false,
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                width: "full",
                height: "auto",
                alignItems: "flex-end",
                paddingX: {
                    base: 4,
                    lg: 0
                },
                justifyContent: "space-between",
                spacing: 2,
                paddingBottom: {
                    base: 6,
                    md: 12,
                    lg: "auto"
                },
                paddingTop: {
                    base: 4,
                    lg: "auto"
                },
                position: {
                    base: "fixed",
                    lg: "static"
                },
                bottom: 0,
                zIndex: theme/* EZIndexLayer.MODAL */.qd.MODAL,
                left: 0,
                background: {
                    base: "white",
                    lg: "none"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV2_styles/* BottomBackButton */.bQ, {
                        onClick: handlePreviousStep,
                        variant: "solid",
                        children: ApplicationFormModalV2_constant/* EBottomButtonValue.BACK */.VF.BACK
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(applicationFormModalV2_styles/* BottomButton */.x_, {
                        onClick: handleSubmitForm,
                        colorScheme: "teal",
                        variant: "solid",
                        id: "submit",
                        rightIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* CheckIcon */.nQ, {}),
                        children: ApplicationFormModalV2_constant/* EBottomButtonValue.COMPLETE */.VF.COMPLETE
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SelectSource = (SelectSource);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js + 1 modules
var chakra_ui_hooks_esm = __webpack_require__(22547);
// EXTERNAL MODULE: ./node_modules/@mapbox/search-js-core/dist/index-esm.js
var dist_index_esm = __webpack_require__(86654);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(57557);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./components/CustomDateInput/index.tsx + 1 modules
var CustomDateInput = __webpack_require__(81195);
// EXTERNAL MODULE: ./components/FormInputWithMask/index.tsx
var FormInputWithMask = __webpack_require__(78000);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chakra-ui-form-control.esm.js + 1 modules
var chakra_ui_form_control_esm = __webpack_require__(3789);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/chakra-ui-spinner.esm.js
var chakra_ui_spinner_esm = __webpack_require__(49609);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./components/pages/DetailPage/components/DropdownSelection/index.tsx
var DropdownSelection = __webpack_require__(93638);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js
var chakra_ui_system_esm = __webpack_require__(46052);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/ShareYourDeets/components/AutoFillInput/autoFillInput.styles.ts

var ResultWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* VStack */.gC, {
    baseStyle: function() {
        return {
            marginTop: "-24px",
            div: {
                minWidth: "100% !important",
                marginTop: "-16px"
            }
        };
    }
});

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/ShareYourDeets/components/AutoFillInput/index.tsx











var AutoFillInput = function(props) {
    var onClickDropdownOption = function onClickDropdownOption(option) {
        setChosenAddress(option);
        setDefaultOptions([]);
        onCloseDropdown();
    };
    var isLoading = props.isLoading, defaultOptions = props.defaultOptions, setDefaultOptions = props.setDefaultOptions, setChosenAddress = props.setChosenAddress, setAddress = props.setAddress, isOpenDropdown = props.isOpenDropdown, onCloseDropdown = props.onCloseDropdown;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, errors = ref.formState.errors;
    var changeAddress = (0,react.useCallback)(debounce_default()(function(event) {
        var ref;
        var ref1;
        setAddress((ref1 = event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : "");
    }, 1000), []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* VStack */.gC, {
        alignItems: "flex-start",
        width: "100%",
        spacing: 0,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_form_control_esm/* FormControl */.NI, {
            isInvalid: !!get_default()(errors, "addressLine1", false),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                    color: "gray.700",
                    lineHeight: 6,
                    marginInlineEnd: 0,
                    children: "Address Line 1"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_input_esm/* InputGroup */.BZ, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            autoComplete: "off",
                            placeholder: "e.g. 1 Shadyhill Road"
                        }, register("addressLine1", {
                            required: "Address Line 1 is required"
                        })), {
                            onChange: changeAddress
                        })),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_input_esm/* InputRightElement */.xH, {
                            children: isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_spinner_esm/* Spinner */.$, {
                                size: "sm"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_menu_esm/* Menu */.v2, {
                    autoSelect: false,
                    computePositionOnMount: true,
                    matchWidth: true,
                    isOpen: isOpenDropdown,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* MenuButton */.j2, {
                            visibility: "hidden",
                            maxH: "0",
                            fontSize: "md",
                            marginTop: "-24px !important"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResultWrapper, {
                            spacing: 0,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_menu_esm/* MenuList */.qy, {
                                zIndex: 100,
                                children: (0,utils_common/* getValidArray */._b)(defaultOptions).map(function(option, index) {
                                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownSelection/* default */.Z, {
                                        onClick: function() {
                                            onClickDropdownOption(option);
                                        },
                                        label: option === null || option === void 0 ? void 0 : option.label,
                                        width: "full"
                                    }, "addressLine1-".concat(index));
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_form_control_esm/* FormErrorMessage */.J1, {
                    children: get_default()(errors, "addressLine1.message", "")
                })
            ]
        })
    });
};
/* harmony default export */ var components_AutoFillInput = (AutoFillInput);

// EXTERNAL MODULE: ./enums/media/index.ts
var enums_media = __webpack_require__(50898);
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__(78718);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
// EXTERNAL MODULE: ./components/MultiCarousel/index.tsx + 3 modules
var MultiCarousel = __webpack_require__(409);
// EXTERNAL MODULE: ./components/pages/DetailPage/utils.tsx
var DetailPage_utils = __webpack_require__(26704);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/ShareYourDeets/components/ChooseBedroom/chooseBedroom.styles.ts


var MainWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Grid */.rj, {
    baseStyle: function() {
        return {
            gridTemplateColumns: "minmax(0, 1fr))",
            gridColumnGap: {
                base: "0",
                lg: 8
            },
            gridRowGap: {
                base: "0"
            },
            width: "100%"
        };
    }
});
var RoomWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
    baseStyle: function() {
        return {
            width: "100%",
            display: {
                base: "none",
                md: "grid"
            },
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: 4,
            justifyContent: "center",
            background: "white",
            left: 0,
            top: 0
        };
    }
});
var RoomWrapperMobile = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
    baseStyle: function() {
        return {
            display: {
                base: "grid",
                md: "none"
            },
            gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
            width: "100%",
            gap: 4
        };
    }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/chakra-ui-image.esm.js + 1 modules
var chakra_ui_image_esm = __webpack_require__(78428);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/advancedFormat.js
var advancedFormat = __webpack_require__(28734);
var advancedFormat_default = /*#__PURE__*/__webpack_require__.n(advancedFormat);
// EXTERNAL MODULE: ./components/Icon/index.tsx
var Icon = __webpack_require__(11665);
// EXTERNAL MODULE: ./components/MultiCarousel/constants.ts
var constants = __webpack_require__(17991);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(84632);
// EXTERNAL MODULE: ./utils/chakraShouldForwardProp.ts
var chakraShouldForwardProp = __webpack_require__(8650);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/ShareYourDeets/components/ChooseBedroom/components/RoomCard/roomCard.styles.ts



var RoomCardWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: function() {
        return {
            position: "relative",
            marginX: "auto",
            width: "100%",
            justifyContent: "center",
            paddingX: {
                base: "2px",
                md: 0
            }
        };
    }
});
var RoomCardContainer = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Box */.xu, function(props) {
    return {
        width: "100%",
        height: "100%",
        marginX: "auto",
        background: "white",
        boxShadow: {
            base: "base",
            lg: "unset"
        },
        border: props.isChosen ? "4px solid #319795" : "4px solid #E2E8F0",
        borderRadius: "8px",
        rounded: "lg",
        overflow: "hidden",
        cursor: "pointer",
        boxSizing: "border-box"
    };
});
var RoomCardBioContainer = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            paddingY: 3,
            paddingX: 4,
            textAlign: "left"
        };
    }
});
var RoomCardBioTitle = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Text */.xv, function(props) {
    return {
        color: (props === null || props === void 0 ? void 0 : props.blackColor) ? "text.primary" : "text.secondary",
        fontWeight: 600,
        fontSize: "md",
        marginBottom: "8px !important",
        transition: "all 250ms",
        cursor: "pointer",
        "&:hover": {
            transition: "all 250ms",
            color: "text.secondary"
        }
    };
});
var RoomCardBioFooter = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: function() {
        return {
            flexDirection: "column",
            flex: 1,
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer"
        };
    }
});
var RoomCardBioText = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Text */.xv, function(props) {
    return {
        color: (props === null || props === void 0 ? void 0 : props.price) ? "text.secondary" : "text.grey.600",
        fontWeight: (props === null || props === void 0 ? void 0 : props.bold) ? 600 : (props === null || props === void 0 ? void 0 : props.normal) === "true" ? "normal" : 500,
        fontSize: "sm",
        lineHeight: 5,
        whiteSpace: "wrap",
        marginLeft: (props === null || props === void 0 ? void 0 : props.bold) || (props === null || props === void 0 ? void 0 : props.hasMarginLeft) ? "4px !important" : 0,
        marginY: "0 !important"
    };
});
var Flex = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Flex */.kC, function(props) {
    return {
        width: "100%",
        alignItems: "flex-start",
        flexDirection: "column",
        justifyContent: "space-between",
        marginTop: (props === null || props === void 0 ? void 0 : props.price) ? "8px" : 0
    };
}), {
    target: "e17bhtql0"
})("img{min-width:16px !important;}> div:first-of-type > div:first-of-type{min-width:16px !important;align-self:flex-start;padding-top:8px;}");
var RoomCardRadioButton = (0,chakraShouldForwardProp/* default */.Z)(chakra_ui_layout_esm/* Box */.xu, function(props) {
    return {
        width: 5,
        height: 5,
        backgroundColor: "white",
        position: "absolute",
        top: 4,
        right: 4,
        borderRadius: "9999px",
        border: props.isChosen ? "6px solid #319795" : "unset",
        cursor: "pointer"
    };
});
var RoomCardViewHouseButton = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            fontSize: "xs",
            lineHeight: 4,
            fontWeight: 600,
            color: "gray.700",
            paddingX: 2,
            paddingY: 1,
            height: 6,
            border: "1px solid #E2E8F0",
            borderRadius: "6px",
            background: "transparent"
        };
    }
});
var RoomCardViewHouseMobileButton = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            paddingY: 2,
            width: "full",
            marginTop: 2,
            color: "gray.700",
            fontSize: "md",
            lineHeight: 6,
            borderRadius: "6px",
            border: "1px solid #E2E8F0",
            background: "white"
        };
    }
});
var RoomInfoRowMobile = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(chakra_ui_layout_esm/* Flex */.kC, {
    target: "e17bhtql1"
})("span{width:20px !important;}");

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/ShareYourDeets/components/ChooseBedroom/components/RoomCard/utils.ts




dayjs_min_default().extend((advancedFormat_default()));
function getAvailableDateInRoomCard(defaultRoomValue, houseAvailableDate) {
    var NOW_AVAILABLE_DATE_LABEL = "Now";
    var today = new Date();
    var startDate = null;
    var endDate = null;
    if (houseAvailableDate && dayjs_min_default()(houseAvailableDate).isAfter(today)) {
        startDate = houseAvailableDate;
        endDate = dayjs_min_default()(houseAvailableDate).add(1, "month").toDate();
    }
    if (!startDate && !endDate) {
        startDate = dayjs_min_default()(defaultRoomValue === null || defaultRoomValue === void 0 ? void 0 : defaultRoomValue.availableStartDate).toDate();
        endDate = dayjs_min_default()(defaultRoomValue === null || defaultRoomValue === void 0 ? void 0 : defaultRoomValue.availableEndDate).toDate();
    }
    var formattedStartDate = (0,utils_common/* formatAvailableDate */.K3)(startDate);
    var formattedEndDate = (0,utils_common/* formatAvailableDate */.K3)(endDate);
    if (formattedStartDate === NOW_AVAILABLE_DATE_LABEL || formattedEndDate === NOW_AVAILABLE_DATE_LABEL) {
        return NOW_AVAILABLE_DATE_LABEL;
    }
    return formattedStartDate;
}
function getImageMediaUnit(media) {
    var ref, ref1, ref2;
    var ref3, ref4, _url;
    return (ref2 = (ref1 = (ref = (0,utils_common/* getValidArray */._b)(media)) === null || ref === void 0 ? void 0 : ref.filter(function(mediaDetail) {
        return mediaDetail.type === enums_media/* MediaType.IMAGE */.D.IMAGE;
    })) === null || ref1 === void 0 ? void 0 : ref1.sort(function(mediaItemA, mediaItemB) {
        return ((ref3 = mediaItemA === null || mediaItemA === void 0 ? void 0 : mediaItemA.unitOrder) !== null && ref3 !== void 0 ? ref3 : 0) - ((ref4 = mediaItemB === null || mediaItemB === void 0 ? void 0 : mediaItemB.unitOrder) !== null && ref4 !== void 0 ? ref4 : 0);
    })) === null || ref2 === void 0 ? void 0 : ref2.map(function(mediaDetail) {
        return {
            name: mediaDetail.name,
            url: (_url = mediaDetail.url) !== null && _url !== void 0 ? _url : mediaDetail === null || mediaDetail === void 0 ? void 0 : mediaDetail.buildiumUrl
        };
    });
}

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/ShareYourDeets/components/ChooseBedroom/components/RoomCard/index.tsx













dayjs_min_default().extend((advancedFormat_default()));
var RoomCard = function(props) {
    var handleChooseRoom = function handleChooseRoom() {
        buildiumUnitId && setChosenUnitId(buildiumUnitId);
    };
    var handleShow3DRoom = function handleShow3DRoom(event) {
        if (event === null || event === void 0 ? void 0 : event.stopPropagation) event.stopPropagation();
        if (validVrUrl) {
            window.open(validVrUrl, "_blank");
        }
    };
    var ref;
    var price = props.price, name = props.name, defaultRoomValue = props.defaultRoomValue, availableDate = props.availableDate, buildiumUnitId = props.buildiumUnitId, _isFullWidth = props.isFullWidth, isFullWidth = _isFullWidth === void 0 ? false : _isFullWidth, media = props.media, isChosen = props.isChosen, setChosenUnitId = props.setChosenUnitId, vrUrl = props.vrUrl;
    var isMobile = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.MD */.yE.MD);
    var roomImages = getImageMediaUnit(media);
    var ref1;
    var validRoomImages = !isEmpty_default()(roomImages) ? (0,utils_common/* getValidArray */._b)(roomImages) : (0,utils_common/* getDefaultSlide */.bC)(constants/* defaultSlide */.p, (ref1 = defaultRoomValue === null || defaultRoomValue === void 0 ? void 0 : defaultRoomValue.roomDefaultImage) !== null && ref1 !== void 0 ? ref1 : (ref = constants/* defaultSlide.0 */.p[0]) === null || ref === void 0 ? void 0 : ref.url);
    var mainRoomImage = validRoomImages[0];
    var validVrUrl = (vrUrl === null || vrUrl === void 0 ? void 0 : vrUrl.includes("http")) ? vrUrl : "";
    var availableDateInRoomCard = getAvailableDateInRoomCard(defaultRoomValue, availableDate);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCardWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCardContainer, {
            isChosen: isChosen,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* AspectRatio */.oM, {
                    ratio: 16 / 9,
                    height: {
                        base: "159px",
                        md: "198px",
                        lg: "136px"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_image_esm/* Img */.Ei, {
                        src: mainRoomImage.url,
                        alt: mainRoomImage.name,
                        onClick: handleChooseRoom,
                        cursor: "pointer"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCardRadioButton, {
                    isChosen: isChosen,
                    onClick: handleChooseRoom
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCardBioContainer, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCardBioTitle, {
                                    noMargin: true,
                                    blackColor: true,
                                    onClick: handleChooseRoom,
                                    children: name
                                }),
                                !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCardViewHouseButton, {
                                    onClick: handleShow3DRoom,
                                    isDisabled: !validVrUrl,
                                    children: "3D Tour"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCardBioFooter, {
                            onClick: handleChooseRoom,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex, {
                                    gap: 2,
                                    children: [
                                        isMobile && !isFullWidth ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomInfoRowMobile, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                                    width: 4,
                                                    height: 4,
                                                    paddingTop: "1px !important",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        iconName: "circle_check_gray.svg",
                                                        size: 16
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCardBioText, {
                                                    bold: true,
                                                    children: "Avail: ".concat(availableDateInRoomCard)
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                                    width: 4,
                                                    height: 4,
                                                    paddingTop: "1px !important",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        iconName: "circle_check_gray.svg",
                                                        size: 16
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCardBioText, {
                                                    bold: true,
                                                    children: "Avail: ".concat(availableDateInRoomCard)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                    iconName: "price_tag.svg",
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RoomCardBioText, {
                                                    price: true,
                                                    bold: true,
                                                    children: [
                                                        "$",
                                                        price,
                                                        "+/mo"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCardViewHouseMobileButton, {
                                    onClick: handleShow3DRoom,
                                    isDisabled: !validVrUrl,
                                    children: "3D Tour"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_RoomCard = (RoomCard);

// EXTERNAL MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/ShareYourDeets/components/ChooseBedroom/chooseBedroom.module.scss
var chooseBedroom_module = __webpack_require__(13037);
var chooseBedroom_module_default = /*#__PURE__*/__webpack_require__.n(chooseBedroom_module);
;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/ShareYourDeets/components/ChooseBedroom/index.tsx















var ChooseBedroom = function() {
    var getRoomCardProps = function getRoomCardProps(room, defaultRoomValue) {
        var ref;
        var ref1;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pick_default()(room, "price", "name", "id", "availableStartDate", "availableEndDate", "buildiumUnitId", "media")), {
            availableDate: room === null || room === void 0 ? void 0 : (ref = room.listing) === null || ref === void 0 ? void 0 : ref.availableDate,
            houseMedia: media,
            defaultRoomValue: defaultRoomValue,
            setChosenUnitId: typeof setChosenUnitId === "function" ? setChosenUnitId : function() {},
            isChosen: chosenUnitId === (room === null || room === void 0 ? void 0 : room.buildiumUnitId),
            vrUrl: (ref1 = room === null || room === void 0 ? void 0 : room.vrTourUrl) !== null && ref1 !== void 0 ? ref1 : vrUrl
        });
    };
    var ref = (0,react.useContext)(applicationForm_context/* ApplicationContext */.Z), houseDetail = ref.houseDetail, chosenUnitId = ref.chosenUnitId, setChosenUnitId = ref.setChosenUnitId;
    var ref1;
    var roomList = (0,utils_common/* getValidArray */._b)((ref1 = houseDetail === null || houseDetail === void 0 ? void 0 : houseDetail.units) !== null && ref1 !== void 0 ? ref1 : []);
    var isMoreRooms = (roomList === null || roomList === void 0 ? void 0 : roomList.length) > 1;
    var ref2 = houseDetail !== null && houseDetail !== void 0 ? houseDetail : {}, _media = ref2.media, media = _media === void 0 ? [] : _media;
    var defaultRoom = {};
    var videoUrl = get_default()((0,DetailPage_utils/* getMedia */.om)(media, enums_media/* MediaType.VIDEO */.D.VIDEO), "[0].url", "");
    var vrUrl = get_default()((0,DetailPage_utils/* getMedia */.om)(media, enums_media/* MediaType.VR */.D.VR), "[0].url", (0,utils_common/* prependHTTPSToUrl */.MH)(videoUrl));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        spacing: {
            base: 2,
            lg: 4
        },
        alignItems: "flex-start",
        width: "full",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                fontSize: "md",
                lineHeight: 6,
                fontWeight: 500,
                color: "gray.700",
                children: "Choose Bedroom"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* GridItem */.P4, {
                    rowStart: {
                        base: 2,
                        lg: 1
                    },
                    display: {
                        base: "flex",
                        md: "block"
                    },
                    flexDirection: {
                        base: "column",
                        md: "unset"
                    },
                    width: "full",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomWrapper, {
                            children: roomList.map(function(room) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_RoomCard, (0,_object_spread/* default */.Z)({}, getRoomCardProps(room, defaultRoom)))
                                }, room.id);
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomWrapperMobile, {
                            children: !isMoreRooms ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                minHeight: {
                                    base: 180,
                                    lg: 360
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_RoomCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRoomCardProps(roomList[0], defaultRoom)), {
                                    isFullWidth: true
                                }))
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultiCarousel/* default */.Z, {
                                className: (chooseBedroom_module_default()).sliderFrame,
                                slidesToShow: 1.2,
                                showArrows: false,
                                showDots: false,
                                dragging: true,
                                children: (0,utils_common/* getValidArray */._b)(roomList).map(function(room, index) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                                        columns: 1,
                                        marginRight: 3,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_RoomCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRoomCardProps(room, defaultRoom)), {
                                            isFullWidth: false
                                        }))
                                    }, index);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_ChooseBedroom = (ChooseBedroom);

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/ShareYourDeets/utils.ts




function getOptions(addressList) {
    var addressOptions = (0,utils_common/* getValidArray */._b)(addressList).map(function(addressSuggestion) {
        return (0,_object_spread/* default */.Z)({
            value: addressSuggestion === null || addressSuggestion === void 0 ? void 0 : addressSuggestion.id,
            label: addressSuggestion === null || addressSuggestion === void 0 ? void 0 : addressSuggestion.fullAddress
        }, addressSuggestion);
    });
    return addressOptions;
}
function handleChangeAddress(closeDropDown, setIsLoading, houseApplicationStore, address, newSessionToken, setDefaultOptions, openDropDown) {
    return _handleChangeAddress.apply(this, arguments);
}
function _handleChangeAddress() {
    _handleChangeAddress = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(closeDropDown, setIsLoading, houseApplicationStore, address, newSessionToken, setDefaultOptions, openDropDown) {
        var result, addressOption;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    closeDropDown();
                    setIsLoading(true);
                    _ctx.next = 4;
                    return houseApplicationStore.getMapboxAddress({
                        address: address,
                        sessionToken: newSessionToken
                    });
                case 4:
                    result = _ctx.sent;
                    addressOption = getOptions(result);
                    if (addressOption.length > 0) {
                        setDefaultOptions(addressOption);
                        openDropDown();
                        setIsLoading(false);
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _handleChangeAddress.apply(this, arguments);
}

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/components/ShareYourDeets/index.tsx






















var ShareYourDeets = function(props) {
    var _showChooseBedRoom = props.showChooseBedRoom, showChooseBedRoom = _showChooseBedRoom === void 0 ? true : _showChooseBedRoom;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, setValue = ref.setValue, control = ref.control, reset = ref.reset, getValues = ref.getValues;
    var houseApplicationStore = (0,useStores/* useStores */.m)().houseApplicationStore;
    var isEntireHouse = (0,react.useContext)(applicationForm_context/* ApplicationContext */.Z).isEntireHouse;
    var moveDate = (0,index_esm/* useWatch */.qo)({
        control: control,
        name: "moveInDate"
    }) || new Date();
    var isTablet = (0,useBreakPoint/* default */.Z)(theme/* EBreakPoint.BASE */.yE.BASE, theme/* EBreakPoint.LG */.yE.LG);
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)([]), defaultOptions = ref2[0], setDefaultOptions = ref2[1];
    var ref3 = (0,react.useState)(), chosenAddress = ref3[0], setChosenAddress = ref3[1];
    var ref4 = (0,react.useState)(""), address = ref4[0], setAddress = ref4[1];
    var ref5 = (0,chakra_ui_hooks_esm/* useDisclosure */.qY)(), isOpen = ref5.isOpen, onOpen = ref5.onOpen, onClose = ref5.onClose;
    var formData = getValues();
    var ref6 = (0,react.useState)(""), newSessionToken = ref6[0], setNewSessionToken = ref6[1];
    (0,react.useEffect)(function() {
        if (!isEmpty_default()(chosenAddress)) {
            reset((0,_object_spread/* default */.Z)({}, formData, omit_default()(chosenAddress, [
                "id",
                "label",
                "value",
                "fullAddress"
            ])));
        }
    }, [
        chosenAddress
    ]);
    (0,react.useEffect)(function() {
        if (address) {
            handleChangeAddress(onClose, setIsLoading, houseApplicationStore, address, newSessionToken, setDefaultOptions, onOpen);
        } else {
            setDefaultOptions([]);
            setChosenAddress({});
            onClose();
        }
    }, [
        address
    ]);
    (0,react.useEffect)(function() {
        var sessionToken = new dist_index_esm/* SessionToken */.lE();
        setNewSessionToken(sessionToken === null || sessionToken === void 0 ? void 0 : sessionToken.id);
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
        spacing: {
            base: 6,
            lg: 8
        },
        paddingX: 4,
        marginTop: {
            base: 0,
            lg: 32
        },
        paddingTop: {
            base: 6,
            lg: 8
        },
        paddingBottom: {
            base: 6,
            md: 14,
            lg: 4
        },
        maxWidth: {
            base: "full",
            lg: "530px"
        },
        marginBottom: {
            base: "65px",
            lg: 0
        },
        marginX: "auto",
        width: "full",
        children: [
            !isEntireHouse && showChooseBedRoom && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ChooseBedroom, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                alignItems: "flex-start",
                width: "full",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "md",
                        fontWeight: 500,
                        color: "gray.700",
                        alignSelf: "flex-start",
                        children: "About when would you want to move in?"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        width: {
                            base: "fit-content",
                            lg: "full"
                        },
                        alignSelf: {
                            base: "center",
                            md: "flex-start"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                            name: "moveInDate",
                            autoComplete: "off",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((react_datepicker_min_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("moveInDate")), {
                                selected: moveDate,
                                minDate: new Date(),
                                onChange: function(date) {
                                    return setValue("moveInDate", date);
                                },
                                customInput: /*#__PURE__*/ (0,react.createElement)(/*#__PURE__*/ (0,react.forwardRef)(CustomDateInput/* default */.Z)),
                                inline: isTablet,
                                showPopperArrow: false,
                                calendarClassName: classnames_default()((0,_define_property/* default */.Z)({}, "isMobile", isTablet)),
                                calendarStartDay: 1
                            }))
                        })
                    })
                ]
            }),
            isTablet ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                spacing: 2,
                alignItems: "flex-start",
                width: "full",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "md",
                        fontWeight: "500",
                        color: "gray.700",
                        children: "Date of Birth"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* HStack */.Ug, {
                        spacing: 4,
                        alignItems: "flex-start",
                        width: "full",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInputWithMask/* default */.Z, {
                                name: "month",
                                label: "Month",
                                format: "##",
                                placeholder: "MM",
                                mask: "M",
                                isSmallLabel: true,
                                autoComplete: "off",
                                onValueChange: function(numberValues) {
                                    var ref;
                                    if (((ref = numberValues.value) === null || ref === void 0 ? void 0 : ref.length) === 2) {
                                        var monthInputElement = document.getElementById("day");
                                        monthInputElement && monthInputElement.focus();
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInputWithMask/* default */.Z, {
                                name: "day",
                                id: "day",
                                label: "Day",
                                format: "##",
                                placeholder: "DD",
                                mask: "D",
                                isSmallLabel: true,
                                autoComplete: "off",
                                onValueChange: function(numberValues) {
                                    var ref;
                                    if (((ref = numberValues.value) === null || ref === void 0 ? void 0 : ref.length) === 2) {
                                        var yearInputElement = document.getElementById("year");
                                        yearInputElement && yearInputElement.focus();
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInputWithMask/* default */.Z, {
                                name: "year",
                                id: "year",
                                label: "Year",
                                format: "####",
                                placeholder: "YYYY",
                                mask: "Y",
                                isSmallLabel: true,
                                autoComplete: "off"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInputWithMask/* default */.Z, {
                name: "dateOfBirth",
                label: "Date of Birth",
                format: "##/##/####",
                placeholder: "MM/DD/YYYY",
                mask: [
                    "M",
                    "M",
                    "D",
                    "D",
                    "Y",
                    "Y",
                    "Y",
                    "Y"
                ],
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInputWithMask/* default */.Z, {
                name: "ssn",
                label: "SSN (Required background check)",
                placeholder: "e.g. 123-45-6789",
                format: "###-##-####",
                mask: "X",
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                name: "monthlyIncome",
                label: "Your current monthly income",
                placeholder: "$0.00",
                autoComplete: "off",
                isRequired: false
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                fontSize: "md",
                fontWeight: 600,
                color: "gray.700",
                alignSelf: "flex-start",
                children: "Most recent permanent address"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* HStack */.Ug, {
                width: "full",
                spacing: 0,
                marginTop: "16px !important",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_AutoFillInput, {
                    isLoading: isLoading,
                    defaultOptions: defaultOptions,
                    setDefaultOptions: setDefaultOptions,
                    setChosenAddress: setChosenAddress,
                    setAddress: setAddress,
                    isOpenDropdown: isOpen,
                    onCloseDropdown: onClose
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                name: "addressLine2",
                label: "Address Line 2",
                placeholder: "Enter Address line 2",
                disabled: isLoading,
                isRequired: false,
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                name: "city",
                label: "City",
                placeholder: "Enter City",
                disabled: isLoading,
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                name: "state",
                label: "State",
                placeholder: "Enter State",
                disabled: isLoading,
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInput/* default */.Z, {
                name: "zipCode",
                label: "Zip Code",
                placeholder: "Enter Zip Code",
                disabled: isLoading,
                autoComplete: "off"
            })
        ]
    });
};
/* harmony default export */ var components_ShareYourDeets = (ShareYourDeets);

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/utils/handleSteps.tsx






var EApplicationStepsLabel;
(function(EApplicationStepsLabel) {
    EApplicationStepsLabel["DO_YOU_QUALIFY"] = "Do you qualify?";
    EApplicationStepsLabel["SHARE_YOUR_DEETS"] = "Share your deets";
    EApplicationStepsLabel["COMPLETE_SCREENING"] = "Complete screening";
    EApplicationStepsLabel["COMPLETED"] = "Completed";
})(EApplicationStepsLabel || (EApplicationStepsLabel = {}));
function getApplicationSteps() {
    return [
        {
            label: EApplicationStepsLabel.DO_YOU_QUALIFY,
            content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DoYouQualify, {})
        },
        {
            label: EApplicationStepsLabel.SHARE_YOUR_DEETS,
            content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ShareYourDeets, {})
        },
        {
            label: EApplicationStepsLabel.COMPLETE_SCREENING,
            content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CompleteScreening, {})
        },
        {
            label: EApplicationStepsLabel.COMPLETED,
            content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_SelectSource, {})
        }
    ];
}

;// CONCATENATED MODULE: ./components/pages/DetailPage/components/ApplicationFormModalV2/utils/index.ts






/***/ }),

/***/ 21325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C9": function() { return /* binding */ TEST_CRS_CRIMINAL_MOCK_DATA; },
/* harmony export */   "Kk": function() { return /* binding */ PAYSTUBS_REQUIRED_QUANTITY; },
/* harmony export */   "QZ": function() { return /* binding */ STRIPE_PUBLISHABLE_KEY; },
/* harmony export */   "Qw": function() { return /* binding */ APPLICATION_TEST_FEE; },
/* harmony export */   "Uq": function() { return /* binding */ TEST_CRS_CREDIT_SCORE_MOCK_DATA; },
/* harmony export */   "VF": function() { return /* binding */ EBottomButtonValue; },
/* harmony export */   "X0": function() { return /* binding */ EApplicationStepBar; },
/* harmony export */   "_G": function() { return /* binding */ TEST_CRS_EVICTION_MOCK_DATA; },
/* harmony export */   "cX": function() { return /* binding */ APPLICATION_FEE; },
/* harmony export */   "fU": function() { return /* binding */ refererSource; },
/* harmony export */   "fh": function() { return /* binding */ TEST_CRS_EMAIL_SUB; },
/* harmony export */   "n2": function() { return /* binding */ DESKTOP_CONTAINER_WIDTH; },
/* harmony export */   "u9": function() { return /* binding */ TABLET_CONTAINER_WIDTH; },
/* harmony export */   "xK": function() { return /* binding */ EApplicationCompletedStateV3; }
/* harmony export */ });
/* unused harmony exports EApplicationCompletedStateV2, EDriverLicenseTypeEnum, DOCUSIGN_LOADING_PAGE_URL, SECURITY_DEPOSIT */
var STRIPE_PUBLISHABLE_KEY = "pk_live_51L2eFOKWNOHUbCIwy4bktsK1r9WY7x8oSMAUlHAJ7Rb6nYTaufYoRImrjIB1tPKs6QXSf6plE2Ki1nULNdSNmfUe00kPVhK5ry";
var refererSource = [
    "Apartments.com",
    "Craigslist",
    "Facebook Group",
    "Facebook Marketplace",
    "Facebook Ad",
    "Livehomeroom.com",
    "Realtor.com",
    "RentPath",
    "Roomster",
    "Zumper",
    "Other"
];
var EApplicationStepBar;
(function(EApplicationStepBar) {
    EApplicationStepBar[EApplicationStepBar["APPLICATION_INFORMATION"] = 0] = "APPLICATION_INFORMATION";
    EApplicationStepBar[EApplicationStepBar["PAYMENT"] = 1] = "PAYMENT";
    EApplicationStepBar[EApplicationStepBar["COMPLETE_SCREENING"] = 2] = "COMPLETE_SCREENING";
    EApplicationStepBar[EApplicationStepBar["COMPLETED"] = 3] = "COMPLETED";
})(EApplicationStepBar || (EApplicationStepBar = {}));
var EApplicationCompletedStateV2;
(function(EApplicationCompletedStateV2) {
    EApplicationCompletedStateV2["PHONE_NUMBER_SUBMITTED"] = "Phone number submitted";
    EApplicationCompletedStateV2["OTP_VERIFIED"] = "OTP verified";
    EApplicationCompletedStateV2["BASIC_INFORMATION_SUBMITTED"] = "Basic information submitted";
    EApplicationCompletedStateV2["PAYMENT_SUBMITTED"] = "Background information and most recent address submitted";
    EApplicationCompletedStateV2["COMPLETE_SCREENING_SUBMITTED"] = "Drivers license, fee payment and paystub uploader submitted";
    EApplicationCompletedStateV2["FULL_APPLICATION_COMPLETED"] = "Full application completed";
    EApplicationCompletedStateV2["BLANK"] = "";
})(EApplicationCompletedStateV2 || (EApplicationCompletedStateV2 = {}));
var EApplicationCompletedStateV3;
(function(EApplicationCompletedStateV3) {
    EApplicationCompletedStateV3["PHONE_NUMBER_SUBMITTED"] = "Phone number submitted";
    EApplicationCompletedStateV3["BASIC_INFORMATION_SUBMITTED"] = "Basic information submitted";
    EApplicationCompletedStateV3["PAYMENT_SUBMITTED"] = "Payment submitted";
    EApplicationCompletedStateV3["COMPLETE_SCREENING_SUBMITTED"] = "Complete screening submitted";
    EApplicationCompletedStateV3["FULL_APPLICATION_COMPLETED"] = "Full application completed";
    EApplicationCompletedStateV3["BLANK"] = "";
})(EApplicationCompletedStateV3 || (EApplicationCompletedStateV3 = {}));
var EDriverLicenseTypeEnum;
(function(EDriverLicenseTypeEnum) {
    EDriverLicenseTypeEnum["ACCEPT"] = "accept";
    EDriverLicenseTypeEnum["REVIEW"] = "review";
    EDriverLicenseTypeEnum["REJECT"] = "reject";
})(EDriverLicenseTypeEnum || (EDriverLicenseTypeEnum = {}));
var EBottomButtonValue;
(function(EBottomButtonValue) {
    EBottomButtonValue["BACK"] = "Back";
    EBottomButtonValue["CONTINUE"] = "Continue";
    EBottomButtonValue["SUBMIT"] = "Submit Application";
    EBottomButtonValue["COMPLETE"] = "Complete";
})(EBottomButtonValue || (EBottomButtonValue = {}));
var DESKTOP_CONTAINER_WIDTH = "600px";
var TABLET_CONTAINER_WIDTH = "736px";
// INFO: mock data using for testing CRS check on SandBox
var TEST_CRS_EMAIL_SUB = ".test-crs@yopmail.com";
var TEST_CRS_CREDIT_SCORE_MOCK_DATA = {
    firstName: "daisy",
    lastName: "oogrd",
    ssn: "666268141",
    dob: "1969-01-27",
    city: "HONOLULU",
    state: "HI",
    phone: "0000000000"
};
var TEST_CRS_CRIMINAL_MOCK_DATA = {
    last: "Consumer",
    first: "Jonathan",
    dob: "01-01-1982",
    ssn: "666-44-3321",
    city: "Cottonwood",
    state: "CA",
    zip: "91502"
};
var TEST_CRS_EVICTION_MOCK_DATA = {
    last: "Consumer",
    first: "Jonathan",
    dob: "01-01-1982",
    ssn: "666-44-3321",
    houseNumber: "1803",
    streetName: "Norma",
    city: "Cottonwood",
    state: "CA",
    zip: "91502"
};
var DOCUSIGN_LOADING_PAGE_URL = "".concat("https://app.livehomeroom.com", "/docusign-loading");
var SECURITY_DEPOSIT = 350;
var APPLICATION_FEE = 35;
var APPLICATION_TEST_FEE = 0.5;
var PAYSTUBS_REQUIRED_QUANTITY = 3;


/***/ }),

/***/ 93638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42349);


var DropdownSelection = function(props) {
    var onClick = props.onClick, label = props.label, isSelected = props.isSelected, width = props.width, minWidth = props.minWidth, maxWidth = props.maxWidth, isTable = props.isTable;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .MenuItem */ .sN, {
        padding: "8px 16px",
        width: width !== null && width !== void 0 ? width : {
            base: "400px",
            lg: "178px"
        },
        minWidth: minWidth,
        maxWidth: maxWidth,
        onClick: onClick,
        className: "dropdown-selection",
        //*INFO: teal.500 with opacity: 0.15
        _hover: {
            background: "#E0EFEF"
        },
        background: isSelected ? "#E0EFEF" : "none",
        paddingLeft: isTable ? {
            base: "45px",
            md: "16px"
        } : 4,
        children: label
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DropdownSelection);


/***/ }),

/***/ 72312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4612);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3789);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87536);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57333);
/* harmony import */ var constants_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88501);
/* harmony import */ var utils_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6628);







var FormPhoneInput = function() {
    var onPastePhoneInput = function onPastePhoneInput(event) {
        var clipboardData = event.clipboardData;
        var pastedPhoneNumber = clipboardData.getData("Text").replace(/\n/g, "");
        if (pastedPhoneNumber.startsWith("+1")) {
            var phoneNumber = (0,utils_common__WEBPACK_IMPORTED_MODULE_3__/* .formatUSPhoneNumber */ .uX)(pastedPhoneNumber);
            reset({
                phoneNumber: phoneNumber
            });
        }
    };
    var ref;
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useFormContext */ .Gc)(), control = ref1.control, errors = ref1.formState.errors, reset = ref1.reset;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .Controller */ .Qr, {
                name: "phoneNumber",
                control: control,
                rules: {
                    required: "Phone number is required",
                    pattern: {
                        value: constants_common__WEBPACK_IMPORTED_MODULE_5__/* .PHONE_NUMBER_PATTERN */ .Cx,
                        message: "Invalid Phone Number"
                    }
                },
                render: function(param) {
                    var _field = param.field, onChange = _field.onChange, value = _field.value;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Input */ .II, {
                        as: react_number_format__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                        value: value,
                        onChange: onChange,
                        format: "(###) ###-####",
                        placeholder: "Enter Your Phone Number",
                        marginTop: "0 !important",
                        height: {
                            base: "48px",
                            lg: "40px"
                        },
                        fontSize: {
                            base: "lg",
                            lg: "md"
                        },
                        onPaste: onPastePhoneInput
                    });
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .FormErrorMessage */ .J1, {
                marginTop: "8px !important",
                display: {
                    base: "block",
                    md: "none",
                    lg: "block"
                },
                children: (errors === null || errors === void 0 ? void 0 : errors.phoneNumber) && (errors === null || errors === void 0 ? void 0 : (ref = errors.phoneNumber) === null || ref === void 0 ? void 0 : ref.message)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormPhoneInput);


/***/ }),

/***/ 26704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$M": function() { return /* binding */ getAllBuildiumUnitIds; },
/* harmony export */   "UI": function() { return /* binding */ getListingMedia; },
/* harmony export */   "_m": function() { return /* binding */ getButtonProps; },
/* harmony export */   "om": function() { return /* binding */ getMedia; },
/* harmony export */   "t1": function() { return /* binding */ getImageMediaUnit; },
/* harmony export */   "uy": function() { return /* binding */ getAmenitiesDataWithIcon; }
/* harmony export */ });
/* unused harmony export leadingNumberRegex */
/* harmony import */ var enums_media__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50898);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6628);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63516);




function getButtonProps(isActive, isFullWidth) {
    return isActive ? {
        colorScheme: "teal",
        borderColor: "teal",
        isFullWidth: isFullWidth !== null && isFullWidth !== void 0 ? isFullWidth : undefined
    } : {
        isFullWidth: isFullWidth !== null && isFullWidth !== void 0 ? isFullWidth : undefined
    };
}
function getMedia(media) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : enums_media__WEBPACK_IMPORTED_MODULE_0__/* .MediaType.IMAGE */ .D.IMAGE;
    var ref, ref1, ref2;
    var _url;
    return (ref2 = (ref1 = (ref = (0,utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getValidArray */ ._b)(media)) === null || ref === void 0 ? void 0 : ref.filter(function(mediaDetail) {
        return mediaDetail.type === type;
    })) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
        return a.order - b.order;
    })) === null || ref2 === void 0 ? void 0 : ref2.map(function(mediaDetail) {
        return {
            name: mediaDetail.name,
            url: (_url = mediaDetail.url) !== null && _url !== void 0 ? _url : mediaDetail === null || mediaDetail === void 0 ? void 0 : mediaDetail.buildiumUrl
        };
    });
}
function getListingMedia(media) {
    return (0,utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getValidArray */ ._b)(media).map(function(mediaDetail) {
        return {
            name: mediaDetail === null || mediaDetail === void 0 ? void 0 : mediaDetail.name,
            url: mediaDetail === null || mediaDetail === void 0 ? void 0 : mediaDetail.url
        };
    });
}
function getAmenitiesDataWithIcon(amenities, enabledKeys) {
    var amenitiesData = [];
    for(var key in amenities){
        if (enabledKeys.includes(key)) {
            var defaultLabel = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(_constants__WEBPACK_IMPORTED_MODULE_3__/* .defaultAmenities */ .sO, key);
            var label = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(amenities, key, defaultLabel);
            var iconName = _constants__WEBPACK_IMPORTED_MODULE_3__/* .AMENITIES_ICON_MAP */ .i7[key];
            if (label) {
                amenitiesData.push({
                    label: label,
                    iconName: iconName
                });
            }
        }
    }
    return amenitiesData;
}
function getAllBuildiumUnitIds(houseDetail) {
    var ref;
    return (0,utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getValidArray */ ._b)(houseDetail === null || houseDetail === void 0 ? void 0 : houseDetail.units).map(function(unit) {
        return (ref = unit === null || unit === void 0 ? void 0 : unit.buildiumUnitId) !== null && ref !== void 0 ? ref : 0;
    });
}
function getImageMediaUnit(media) {
    var ref, ref1, ref2;
    var ref3, ref4, _url;
    return (ref2 = (ref1 = (ref = (0,utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getValidArray */ ._b)(media)) === null || ref === void 0 ? void 0 : ref.filter(function(mediaDetail) {
        return mediaDetail.type === enums_media__WEBPACK_IMPORTED_MODULE_0__/* .MediaType.IMAGE */ .D.IMAGE;
    })) === null || ref1 === void 0 ? void 0 : ref1.sort(function(mediaItemA, mediaItemB) {
        return ((ref3 = mediaItemA === null || mediaItemA === void 0 ? void 0 : mediaItemA.unitOrder) !== null && ref3 !== void 0 ? ref3 : 0) - ((ref4 = mediaItemB === null || mediaItemB === void 0 ? void 0 : mediaItemB.unitOrder) !== null && ref4 !== void 0 ? ref4 : 0);
    })) === null || ref2 === void 0 ? void 0 : ref2.map(function(mediaDetail) {
        return {
            name: mediaDetail.name,
            url: (_url = mediaDetail.url) !== null && _url !== void 0 ? _url : mediaDetail === null || mediaDetail === void 0 ? void 0 : mediaDetail.buildiumUrl
        };
    });
}
var leadingNumberRegex = /[0-9]+.\s+/;


/***/ }),

/***/ 88412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ mockBackPhoto; },
/* harmony export */   "L": function() { return /* binding */ mockFrontPhoto; }
/* harmony export */ });
var mockFrontPhoto = "/assets/images/front-side-driver-license.png";
var mockBackPhoto = "/assets/images/back-side-driver-license.png";


/***/ }),

/***/ 28942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "HX": function() { return /* binding */ SidebarWrapper; },
/* harmony export */   "Mm": function() { return /* binding */ SubmitButton; },
/* harmony export */   "R8": function() { return /* binding */ SidebarTitle; },
/* harmony export */   "TZ": function() { return /* binding */ SidebarContent; },
/* harmony export */   "Uq": function() { return /* binding */ SectionWrapper; },
/* harmony export */   "Wi": function() { return /* binding */ FormField; },
/* harmony export */   "eh": function() { return /* binding */ RowWrapper; },
/* harmony export */   "lX": function() { return /* binding */ FormLabel; },
/* harmony export */   "pF": function() { return /* binding */ UploadButton; },
/* harmony export */   "sv": function() { return /* binding */ LogoutButton; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46052);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85054);

var SidebarTitle = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    baseStyle: {
        color: "gray.800",
        lineHeight: 7,
        fontSize: "20px",
        fontWeight: 700,
        display: {
            base: "block",
            lg: "none"
        }
    }
});
var SidebarContent = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .VStack */ .gC, {
    baseStyle: {
        justifyContent: "flex-start",
        height: "100%",
        width: "100%"
    }
});
var SidebarWrapper = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .VStack */ .gC, {
    baseStyle: {
        height: "100%",
        width: {
            base: "100%",
            lg: "256px"
        },
        position: "sticky",
        top: "104px",
        alignItems: "start",
        padding: {
            base: "24px 16px 40px",
            md: "40px 32px",
            lg: "0px"
        }
    }
});
var LogoutButton = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
    baseStyle: {
        border: "1px solid #C53030",
        background: "none",
        display: {
            base: "flex",
            md: "block",
            lg: "none"
        },
        width: {
            base: "100%",
            md: "auto"
        },
        justifyContent: {
            sm: "center"
        }
    }
});
var ContentWrapper = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .VStack */ .gC, {
    baseStyle: {
        paddingX: {
            base: 4,
            md: 8,
            lg: 0
        },
        paddingY: {
            base: 6,
            md: 10,
            lg: 0
        },
        " > form": {
            width: {
                base: "100%"
            }
        }
    }
});
var Title = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    baseStyle: {
        color: "gray.700",
        fontWeight: 600,
        fontSize: "md",
        lineHeight: 6
    }
});
var FormLabel = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    baseStyle: {
        color: "gray.700",
        fontWeight: 500,
        fontSize: "md",
        lineHeight: 6
    }
});
var FormField = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .VStack */ .gC, {
    baseStyle: {
        alignItems: "flex-start",
        flex: 1,
        width: "100%"
    }
});
var SectionWrapper = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .VStack */ .gC, {
    baseStyle: {
        width: "full",
        alignItems: "flex-start",
        padding: {
            base: 4,
            lg: 8
        },
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
        borderRadius: "8px"
    }
});
var SubmitButton = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
    baseStyle: {
        background: "teal.500",
        color: "white",
        lineHeight: 5,
        paddingY: "6px",
        paddingX: 3,
        borderRadius: "6px",
        _active: {
            background: "teal.500"
        },
        _hover: {
            background: "teal.500"
        }
    }
});
var UploadButton = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
    baseStyle: {
        background: "white",
        flexDirection: "row",
        fontSize: {
            base: "lg",
            lg: "md"
        },
        lineHeight: {
            base: 7,
            lg: 6
        },
        width: "full",
        height: {
            base: 12,
            lg: 10
        },
        color: "gray.700",
        border: "1px solid #E2E8F0",
        bordeRadius: "6px"
    }
});
var RowWrapper = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_0__/* .chakra */ .m$)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kq, {
    baseStyle: {
        width: "full",
        gap: {
            md: 6,
            lg: 8
        },
        flexDirection: {
            base: "column",
            md: "row"
        },
        alignItems: {
            md: "flex-start"
        }
    }
});


/***/ }),

/***/ 79251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bf": function() { return /* binding */ CategoryEnum; },
/* harmony export */   "Xv": function() { return /* binding */ ActionEnum; }
/* harmony export */ });
/* unused harmony export PageRouteEnum */
var CategoryEnum;
(function(CategoryEnum) {
    CategoryEnum["USER"] = "User";
    CategoryEnum["SYSTEM"] = "System";
    CategoryEnum["APPLICATION_FORM"] = "Application Form";
    CategoryEnum["CONTACT_FORM"] = "Contact Form";
})(CategoryEnum || (CategoryEnum = {}));
var ActionEnum;
(function(ActionEnum) {
    ActionEnum["PAGE_VIEW"] = "page_view";
    ActionEnum["CLICK"] = "click";
    ActionEnum["LOGIN"] = "sign_in";
    ActionEnum["OAUTH_LOGIN"] = "oAuth-login";
    ActionEnum["SUMMIT_FORM"] = "submit_form";
    ActionEnum["VIEW"] = "view";
    ActionEnum["DETAIL_PAGE_LOADED"] = "detail_page_loaded";
    ActionEnum["OTP_VERIFICATION_STEP_LOADED"] = "otp_verification_step_loaded";
    ActionEnum["PERSONAL_INFO_STEP_LOADED"] = "personal_info_step_loaded";
    ActionEnum["MOVE_IN_DATE_STEP_LOADED"] = "move_in_date_step_loaded";
    ActionEnum["BACKGROUND_INFO_STEP_LOADED"] = "background_info_step_loaded";
    ActionEnum["PAYMENT_STEP_LOADED"] = "payment_step_loaded";
    ActionEnum["SIGN_OR_MEET_ROOMMATE_STEP_LOADED"] = "sign_or_meet_roommate_step_loaded";
    ActionEnum["SIGN_LEASE_CHOSEN"] = "sign_lease_chosen";
    ActionEnum["SIGN_LEASE_URL_OPENED"] = "sign_lease_url_opened";
    ActionEnum["SIGN_LEASE_SIGNED"] = "sign_lease_signed";
    ActionEnum["DRIVER_LICENSE_STEP_LOADED"] = "driver_license_step_loaded";
    ActionEnum["MEET_ROOMMATE_FIRST_STEP_LOADED"] = "meet_roommate_first_step_loaded";
    ActionEnum["REFERRAL_SOURCE_STEP_LOADED"] = "referral_source_step_loaded";
    ActionEnum["APPLICATION_FORM_SUBMITTED"] = "application_form_submitted";
    ActionEnum["CAROUSEL_NEXT_IMAGE_CLICKED"] = "carousel_next_image_clicked";
    ActionEnum["CAROUSEL_PREVIOUS_IMAGE_CLICKED"] = "carousel_previous_image_clicked";
    ActionEnum["LIGHT_BOX_NEXT_IMAGE_CLICKED"] = "light_box_next_image_clicked";
    ActionEnum["LIGHT_BOX_PREVIOUS_IMAGE_CLICKED"] = "light_box_previous_image_clicked";
    ActionEnum["PAYSTUB_STEP_LOADED"] = "paystub_step_loaded";
    ActionEnum["APPLY_NOW_CLICKED"] = "apply_now_clicked";
    ActionEnum["CONTACT_US_TODAY_CLICKED"] = "contact_us_today_clicked";
})(ActionEnum || (ActionEnum = {}));
var PageRouteEnum;
(function(PageRouteEnum) {
    PageRouteEnum["HOUSE_DETAIL"] = "house-detail";
    PageRouteEnum["ROOM_DETAIL"] = "room-detail";
})(PageRouteEnum || (PageRouteEnum = {}));


/***/ }),

/***/ 60234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ pusherChannels; }
/* harmony export */ });
var pusherChannels = {
    leaseAgreement: {
        signed: {
            value: function(applicationId) {
                return "leaseAgreement.signed.".concat(applicationId);
            }
        }
    },
    driverLicense: {
        verified: {
            value: function(customerUid) {
                return "driverLicense.verified.".concat(customerUid);
            }
        }
    }
};


/***/ }),

/***/ 50898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ MediaType; },
/* harmony export */   "h": function() { return /* binding */ MediaMode; }
/* harmony export */ });
var MediaType;
(function(MediaType) {
    MediaType["IMAGE"] = "Image";
    MediaType["VIDEO"] = "Video";
    MediaType["FLOOR_PLAN"] = "FloorPlan";
    MediaType["VR"] = "VR";
})(MediaType || (MediaType = {}));
var MediaMode;
(function(MediaMode) {
    MediaMode["PHOTO"] = "Photo";
    MediaMode["MAP"] = "Map";
    MediaMode["VR"] = "VR";
})(MediaMode || (MediaMode = {}));


/***/ }),

/***/ 85159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ PusherEventName; }
/* harmony export */ });
var PusherEventName;
(function(PusherEventName) {
    PusherEventName["REFETCH"] = "refetch";
})(PusherEventName || (PusherEventName = {}));


/***/ }),

/***/ 68834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUnsavedWarning; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useUnsavedWarning() {
    var enable = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(enable), isDirty = ref[0], setDirty = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var onUnload = function onUnload(event) {
            event = event || window.event;
            if (isDirty) {
                event.preventDefault();
                if (event) {
                    //* INFO: for IE, Firefox,...
                    event.returnValue = "Are you sure you want to leave?";
                }
                //* INFO: for Safari
                return "You have unsaved changes";
            }
            return "";
        };
        //* INFO: Detecting browser closing
        window.addEventListener("beforeunload", onUnload);
        return function() {
            window.removeEventListener("beforeunload", onUnload);
        };
    }, [
        isDirty
    ]);
    return {
        isDirty: isDirty,
        setDirty: setDirty
    };
};


/***/ }),

/***/ 34208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A7": function() { return /* binding */ GET_ATLAS_APP_ID; },
/* harmony export */   "jO": function() { return /* binding */ HEAP_APP_ID; },
/* harmony export */   "nJ": function() { return /* binding */ GOOGLE_TAG_MANAGER_ID; },
/* harmony export */   "pN": function() { return /* binding */ GOOGLE_ANALYTICS_TRACKING_ID; }
/* harmony export */ });
/* unused harmony exports AMPLITUDE_API_KEY, DIALOGFLOW_TOKEN, PODIUM_TOKEN */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25892);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91224);
/* harmony import */ var _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var next_document__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56859);
/* provided dependency */ var process = __webpack_require__(34155);









var _GOOGLE_TAG_MANAGER_ID;
var GOOGLE_TAG_MANAGER_ID = (_GOOGLE_TAG_MANAGER_ID = "GTM-NDWS4RT") !== null && _GOOGLE_TAG_MANAGER_ID !== void 0 ? _GOOGLE_TAG_MANAGER_ID : "";
var _GOOGLE_ANALYTICS_TRACKING_ID;
var GOOGLE_ANALYTICS_TRACKING_ID = (_GOOGLE_ANALYTICS_TRACKING_ID = "G-NEN10P9Z5T") !== null && _GOOGLE_ANALYTICS_TRACKING_ID !== void 0 ? _GOOGLE_ANALYTICS_TRACKING_ID : "";
var _GET_ATLAS_APP_ID;
var GET_ATLAS_APP_ID = (_GET_ATLAS_APP_ID = "hew06hnu4x") !== null && _GET_ATLAS_APP_ID !== void 0 ? _GET_ATLAS_APP_ID : "";
var _AMPLITUDE_API_KEY;
var AMPLITUDE_API_KEY = (_AMPLITUDE_API_KEY = "986c2cc8bf534e8da26f08acccc2928e") !== null && _AMPLITUDE_API_KEY !== void 0 ? _AMPLITUDE_API_KEY : "";
var _HEAP_APP_ID;
var HEAP_APP_ID = (_HEAP_APP_ID = "3909938871") !== null && _HEAP_APP_ID !== void 0 ? _HEAP_APP_ID : "";
var _DIALOGFLOW_TOKEN;
var DIALOGFLOW_TOKEN = (_DIALOGFLOW_TOKEN = "e0044d95-1e93-48d3-a78b-8df15554dc9a") !== null && _DIALOGFLOW_TOKEN !== void 0 ? _DIALOGFLOW_TOKEN : "";
var _PODIUM_TOKEN;
var PODIUM_TOKEN = (_PODIUM_TOKEN = process.env.PODIUM_TOKEN) !== null && _PODIUM_TOKEN !== void 0 ? _PODIUM_TOKEN : "";
var MyDocument = /*#__PURE__*/ function(Document1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(MyDocument, Document1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(MyDocument);
    function MyDocument() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, MyDocument);
        return _super.apply(this, arguments);
    }
    var _proto = MyDocument.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(next_document__WEBPACK_IMPORTED_MODULE_1__.Html, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(next_document__WEBPACK_IMPORTED_MODULE_1__.Head, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("script", {
                            defer: true,
                            src: "https://connect.podium.com/widget.js#ORG_TOKEN=".concat(PODIUM_TOKEN),
                            id: "podium-widget",
                            "data-organization-api-token": "".concat(PODIUM_TOKEN)
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("link", {
                            rel: "stylesheet",
                            href: "https://unpkg.com/leaflet/dist/leaflet.css"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("link", {
                            rel: "stylesheet",
                            href: "https://unpkg.com/react-leaflet-markercluster/dist/styles.min.css"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("script", {
                            defer: true,
                            dangerouslySetInnerHTML: {
                                __html: 'window.heap = window.heap || [], heap.load = function(e, t) {\n                window.heap.appid = e, window.heap.config = t = t || {};\n                var r = document.createElement("script");\n                r.type = "text/javascript", r.async = !0, r.src = "https://cdn.heapanalytics.com/js/heap-" + e + ".js";\n                var a = document.getElementsByTagName("script")[0];\n                a.parentNode.insertBefore(r, a);\n                for (var n = function(e) {\n                        return function() {\n                            heap.push([e].concat(Array.prototype.slice.call(arguments, 0)))\n                        }\n                    }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "resetIdentity", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"], o = 0; o < p.length; o++) heap[p[o]] = n(p[o])\n            };\n            heap.load('.concat(HEAP_APP_ID, ");")
                            }
                        }),
                        GOOGLE_ANALYTICS_TRACKING_ID && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("script", {
                                    async: true,
                                    src: "https://www.googletagmanager.com/gtag/js?id=".concat(GOOGLE_ANALYTICS_TRACKING_ID)
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("script", {
                                    dangerouslySetInnerHTML: {
                                        __html: "\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', '".concat(GOOGLE_ANALYTICS_TRACKING_ID, "', {\n              page_path: window.location.pathname\n            });\n          ")
                                    }
                                })
                            ]
                        }),
                        GOOGLE_TAG_MANAGER_ID && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("script", {
                            dangerouslySetInnerHTML: {
                                __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','".concat(GOOGLE_TAG_MANAGER_ID, "');")
                            }
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "application-name",
                            content: "HomeRoom"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "apple-mobile-web-app-capable",
                            content: "yes"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "apple-mobile-web-app-status-bar-style",
                            content: "default"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "apple-mobile-web-app-title",
                            content: "HomeRoom"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "description",
                            content: "Roommate Living. Perfected."
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "format-detection",
                            content: "telephone=no"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "mobile-web-app-capable",
                            content: "yes"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "msapplication-config",
                            content: "/icons/browserconfig.xml"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "msapplication-TileColor",
                            content: "#2B5797"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "msapplication-tap-highlight",
                            content: "no"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "theme-color",
                            content: "#000000"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("link", {
                            rel: "apple-touch-icon",
                            href: "/icons/touch-icon-iphone.png"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("link", {
                            rel: "apple-touch-icon",
                            sizes: "152x152",
                            href: "/icons/touch-icon-ipad.png"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("link", {
                            rel: "apple-touch-icon",
                            sizes: "180x180",
                            href: "/icons/touch-icon-iphone-retina.png"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("link", {
                            rel: "apple-touch-icon",
                            sizes: "167x167",
                            href: "/icons/touch-icon-ipad-retina.png"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("link", {
                            rel: "manifest",
                            href: "/manifest.json"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "twitter:card",
                            content: "summary"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "twitter:url",
                            content: "https://app.livehomeroom.com"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "twitter:title",
                            content: "HomeRoom"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "twitter:description",
                            content: "Roommate Living. Perfected."
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            name: "twitter:image",
                            content: "https://app.livehomeroom.com/icons/android-chrome-192x192.png"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            property: "og:type",
                            content: "website"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            property: "og:title",
                            content: "HomeRoom"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            property: "og:description",
                            content: "Roommate Living. Perfected."
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            property: "og:site_name",
                            content: "HomeRoom"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("meta", {
                            property: "og:url",
                            content: "https://app.livehomeroom.com"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("body", {
                    children: [
                        GOOGLE_TAG_MANAGER_ID && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("noscript", {
                            dangerouslySetInnerHTML: {
                                __html: '<iframe src="https://www.googletagmanager.com/ns.html?id='.concat(GOOGLE_TAG_MANAGER_ID, '"\n            height="0" width="0" style="display:none;visibility:hidden"></iframe>')
                            }
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(next_document__WEBPACK_IMPORTED_MODULE_1__.Main, {}),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(next_document__WEBPACK_IMPORTED_MODULE_1__.NextScript, {})
                    ]
                })
            ]
        });
    };
    MyDocument.getInitialProps = function getInitialProps(ctx) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var initialProps;
            return _home_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return next_document__WEBPACK_IMPORTED_MODULE_1__["default"].getInitialProps(ctx);
                    case 2:
                        initialProps = _ctx.sent;
                        return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, initialProps));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return MyDocument;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(next_document__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (MyDocument)));


/***/ }),

/***/ 99714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ UploaderIcon; }
/* harmony export */ });
/* unused harmony export FilterIcon */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10894);


//* INFO: https://chakra-ui.com/docs/media-and-icons/icon#tips-for-generating-your-own-icons
//* INFO: using `path`
var FilterIcon = (0,_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_0__/* .createIcon */ .IU)({
    displayName: "FilterIcon",
    viewBox: "0 0 200 200",
    // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
    path: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
        fill: "#2D3748",
        d: "M10 18h4v-2h-4v2ZM3 6v2h18V6H3Zm3 7h12v-2H6v2Z"
    })
});
var UploaderIcon = (0,_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_0__/* .createIcon */ .IU)({
    displayName: "UploaderIcon",
    viewBox: "0 0 16 16",
    path: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
        fill: "#2D3748",
        d: "M8.666 3.885V12H7.333V3.885L3.757 7.461l-.943-.942L8 1.333l5.185 5.186-.943.942-3.576-3.576ZM7.143 13.333H14v1.334H2v-1.334h5.143Z"
    })
}) //* INFO: OR using the `d` value of a path (the path definition) directly
 // export const UpDownIcon = createIcon({
 //   displayName: 'UpDownIcon',
 //   viewBox: '0 0 200 200',
 //   d: 'M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0',
 // })
;


/***/ }),

/***/ 26451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kz": function() { return /* binding */ logEvent; },
/* harmony export */   "bA": function() { return /* binding */ identifyAmplitudeUser; },
/* harmony export */   "st": function() { return /* binding */ identifyAtlasUser; }
/* harmony export */ });
/* unused harmony exports pageView, initAmplitude */
/* harmony import */ var amplitude_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17380);
/* harmony import */ var enums_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71074);
/* harmony import */ var pages_document__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34208);
/* eslint-disable camelcase */ 


//* INFO: log the pageview with their URL
var pageView = function(url) {
    if (GOOGLE_ANALYTICS_TRACKING_ID && (window === null || window === void 0 ? void 0 : window.gtag)) {
        window.gtag("config", GOOGLE_ANALYTICS_TRACKING_ID, {
            // eslint-disable-next-line camelcase
            page_path: url
        });
    }
};
//* INFO: log specific events happening.
var logEvent = function(category, action) {
    if (!category || !action) {
        return;
    }
    // *TODO: remove the Amplitude service and will replace it with Google Analytics
    // if (AMPLITUDE_API_KEY) {
    //   if (!window.amplitude && window) {
    //     initAmplitude()
    //   }
    //   const pageUrl: string = window?.location?.href ?? ''
    //   const lastViewedPropertyId: string | undefined =
    //     localStorage.getItem(LocalStorageKeyEnum.LAST_VIEWED_PROPERTY_ID) || undefined
    //   const amplitudeInstance = amplitude.getInstance()
    //   amplitudeInstance.logEvent(action, { category, lastViewedPropertyId, pageUrl })
    // }
    var utmSource = localStorage.getItem("utm_source");
    var utmMedium = localStorage.getItem("utm_medium");
    var utmCampaign = localStorage.getItem("utm_campaign");
    var eventParams = {
        category: category,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign
    };
    if (pages_document__WEBPACK_IMPORTED_MODULE_2__/* .GOOGLE_ANALYTICS_TRACKING_ID */ .pN && (window === null || window === void 0 ? void 0 : window.gtag)) {
        window.gtag("event", action, eventParams);
    } else {
        ;
    }
};
function identifyAtlasUser(user) {
    var ref;
    if (!(user === null || user === void 0 ? void 0 : user.lastName) && !(user === null || user === void 0 ? void 0 : user.firstName)) {
        return;
    }
    var name = "".concat(user.firstName, " ").concat(user.lastName);
    var ref1;
    var phone = (ref1 = user === null || user === void 0 ? void 0 : user.phoneNumber) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var email = (ref2 = user === null || user === void 0 ? void 0 : user.email) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var photo = (ref3 = user === null || user === void 0 ? void 0 : user.driverLicenseFrontPhotoUrl) !== null && ref3 !== void 0 ? ref3 : "";
    if (pages_document__WEBPACK_IMPORTED_MODULE_2__/* .GET_ATLAS_APP_ID */ .A7 && (window === null || window === void 0 ? void 0 : window.Atlas) && (window === null || window === void 0 ? void 0 : (ref = window.Atlas) === null || ref === void 0 ? void 0 : ref.identify) && phone) {
        var newUser = {
            userId: phone,
            name: name,
            email: email,
            fields: {
                phone: phone,
                photo: photo
            }
        };
        if (!email) {
            newUser === null || newUser === void 0 ? void 0 : delete newUser.email;
        }
        window.Atlas.identify(newUser);
    }
}
function identifyAmplitudeUser(user) {
// *TODO: remove the Amplitude service and will replace it with Google Analytics
// if (!user?.lastName || !user?.firstName) {
//   return
// }
// const phone = user?.phoneNumber ?? ''
// const amplitudeInstance = amplitude.getInstance()
// if (AMPLITUDE_API_KEY && window?.amplitude && phone) {
//   amplitudeInstance.setUserProperties(user)
// }
}
function initAmplitude() {
    var ref;
    var userId = (ref = localStorage.getItem(LocalStorageKeyEnum.PHONE_NUMBER)) !== null && ref !== void 0 ? ref : undefined;
    var amplitudeInstance = amplitude.getInstance();
    amplitudeInstance.init(AMPLITUDE_API_KEY, userId, {
        batchEvents: true,
        eventUploadThreshold: 10,
        eventUploadPeriodMillis: 10000,
        storage: StorageType.LOCAL_STORAGE,
        saveEvents: true,
        includeReferrer: true,
        includeUtm: true,
        includeGclid: true,
        includeFbclid: true,
        logAttributionCapturedEvent: true
    });
    if (window) {
        window.amplitude = amplitudeInstance;
    }
}


/***/ }),

/***/ 92594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ pusher; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var pusher_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86606);
/* harmony import */ var pusher_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pusher_js__WEBPACK_IMPORTED_MODULE_0__);


var PusherService = /*#__PURE__*/ function() {
    "use strict";
    function PusherService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, PusherService);
        this.pusher = null;
        var _PUSHER_KEY;
        this.key = (_PUSHER_KEY = "b4c4faf1cdf77b62a8ee") !== null && _PUSHER_KEY !== void 0 ? _PUSHER_KEY : "";
        var _PUSHER_CLUSTER;
        this.config = {
            cluster: (_PUSHER_CLUSTER = "ap1") !== null && _PUSHER_CLUSTER !== void 0 ? _PUSHER_CLUSTER : ""
        };
    }
    var _proto = PusherService.prototype;
    _proto.getPusher = function getPusher() {
        if (!this.pusher) {
            // Enable pusher logging - don't include this in production
            // Pusher.logToConsole = process.env.ENVIRONMENT !== EnvironmentEnum.PRODUCTION
            this.pusher = new (pusher_js__WEBPACK_IMPORTED_MODULE_0___default())(this.key, this.config);
        }
        return this.pusher;
    };
    return PusherService;
}();
var pusherService = new PusherService();
var pusher = pusherService.getPusher();


/***/ }),

/***/ 57156:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"multiCarousel_container___ff__"};

/***/ }),

/***/ 81647:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"doYouQualify_inputContainer__VUy05","formEmail":"doYouQualify_formEmail__SIcFZ","checkbox":"doYouQualify_checkbox__LbH0h"};

/***/ }),

/***/ 13037:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sliderFrame":"chooseBedroom_sliderFrame__1cXA2"};

/***/ })

}]);